import { emptySplitApiV2 as api } from "./emptyApiV2";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProvidersAdmin: build.query<
      GetProvidersAdminApiResponse,
      GetProvidersAdminApiArg
    >({
      query: () => ({ url: `/v2/admin/expectation-providers` }),
    }),
    createProviderAdmin: build.mutation<
      CreateProviderAdminApiResponse,
      CreateProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers`,
        method: "POST",
        body: queryArg.expectationProviderDto,
      }),
    }),
    deleteProviderAdmin: build.mutation<
      DeleteProviderAdminApiResponse,
      DeleteProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers/${queryArg.providerId}`,
        method: "DELETE",
      }),
    }),
    getProviderAdmin: build.query<
      GetProviderAdminApiResponse,
      GetProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers/${queryArg.providerId}`,
      }),
    }),
    updateProviderAdmin: build.mutation<
      UpdateProviderAdminApiResponse,
      UpdateProviderAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectation-providers/${queryArg.providerId}`,
        method: "PUT",
        body: queryArg.expectationProviderDto,
      }),
    }),
    getExpectationsAdmin: build.query<
      GetExpectationsAdminApiResponse,
      GetExpectationsAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations`,
        params: {
          providerCode: queryArg.providerCode,
        },
      }),
    }),
    createExpectationAdmin: build.mutation<
      CreateExpectationAdminApiResponse,
      CreateExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations`,
        method: "POST",
        body: queryArg.expectationAdminDto,
      }),
    }),
    deleteExpectationAdmin: build.mutation<
      DeleteExpectationAdminApiResponse,
      DeleteExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations/${queryArg.expectationId}`,
        method: "DELETE",
      }),
    }),
    getExpectationAdmin: build.query<
      GetExpectationAdminApiResponse,
      GetExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations/${queryArg.expectationId}`,
      }),
    }),
    updateExpectationAdmin: build.mutation<
      UpdateExpectationAdminApiResponse,
      UpdateExpectationAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/expectations/${queryArg.expectationId}`,
        method: "PUT",
        body: queryArg.expectationAdminDto,
      }),
    }),
    getDataForDiagram: build.query<
      GetDataForDiagramApiResponse,
      GetDataForDiagramApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram`,
        params: {
          tableIds: queryArg.tableIds,
        },
      }),
    }),
    getDiagramById: build.query<
      GetDiagramByIdApiResponse,
      GetDiagramByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram/${queryArg.structureId}`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateDiagram: build.mutation<
      UpdateDiagramApiResponse,
      UpdateDiagramApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.newDiagram,
      }),
    }),
    getDiagramData: build.query<
      GetDiagramDataApiResponse,
      GetDiagramDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram/${queryArg.structureId}/data`,
      }),
    }),
    updateDiagramData: build.mutation<
      UpdateDiagramDataApiResponse,
      UpdateDiagramDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram/${queryArg.structureId}/data`,
        method: "PUT",
        body: queryArg.diagram,
      }),
    }),
    getDiagramOverview: build.query<
      GetDiagramOverviewApiResponse,
      GetDiagramOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram/${queryArg.structureId}/overview`,
      }),
    }),
    updateDiagramOverview: build.mutation<
      UpdateDiagramOverviewApiResponse,
      UpdateDiagramOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.diagramOverview,
      }),
    }),
    getDiagramSvg: build.query<GetDiagramSvgApiResponse, GetDiagramSvgApiArg>({
      query: (queryArg) => ({ url: `/v2/diagram/${queryArg.structureId}/svg` }),
    }),
    updateDiagramSvg: build.mutation<
      UpdateDiagramSvgApiResponse,
      UpdateDiagramSvgApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/diagram/${queryArg.structureId}/svg`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteSystemRelease: build.mutation<
      DeleteSystemReleaseApiResponse,
      DeleteSystemReleaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}`,
        method: "DELETE",
      }),
    }),
    getSystemRelease: build.query<
      GetSystemReleaseApiResponse,
      GetSystemReleaseApiArg
    >({
      query: (queryArg) => ({ url: `/v2/dp/${queryArg.dpId}` }),
    }),
    updateSystemRelease: build.mutation<
      UpdateSystemReleaseApiResponse,
      UpdateSystemReleaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}`,
        method: "PUT",
        body: queryArg.releaseDto,
      }),
    }),
    getReleaseEnvironments: build.query<
      GetReleaseEnvironmentsApiResponse,
      GetReleaseEnvironmentsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/dp/${queryArg.dpId}/environment` }),
    }),
    createReleaseEnvironment: build.mutation<
      CreateReleaseEnvironmentApiResponse,
      CreateReleaseEnvironmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment`,
        method: "POST",
        body: queryArg.releaseEnvironmentDto,
      }),
    }),
    deleteReleaseEnvironment: build.mutation<
      DeleteReleaseEnvironmentApiResponse,
      DeleteReleaseEnvironmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}`,
        method: "DELETE",
      }),
    }),
    updateReleaseEnvironment: build.mutation<
      UpdateReleaseEnvironmentApiResponse,
      UpdateReleaseEnvironmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}`,
        method: "PUT",
        body: queryArg.releaseEnvironmentDto,
      }),
    }),
    pushReleaseToGit: build.mutation<
      PushReleaseToGitApiResponse,
      PushReleaseToGitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}/git`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    createReleasePreview: build.mutation<
      CreateReleasePreviewApiResponse,
      CreateReleasePreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}/preview`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    createReleaseScripts: build.mutation<
      CreateReleaseScriptsApiResponse,
      CreateReleaseScriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}/scripts`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    createDeployments: build.mutation<
      CreateDeploymentsApiResponse,
      CreateDeploymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/environment/${queryArg.envCode}/scripts/deploy`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    getObjectSettings: build.query<
      GetObjectSettingsApiResponse,
      GetObjectSettingsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/dp/${queryArg.dpId}/object-type` }),
    }),
    changeReleaseStatus: build.mutation<
      ChangeReleaseStatusApiResponse,
      ChangeReleaseStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/status/${queryArg.newStatus}`,
        method: "PATCH",
      }),
    }),
    getReleaseStructures: build.query<
      GetReleaseStructuresApiResponse,
      GetReleaseStructuresApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/structure`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    addStructureToRelease: build.mutation<
      AddStructureToReleaseApiResponse,
      AddStructureToReleaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/structure`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteReleaseStructure: build.mutation<
      DeleteReleaseStructureApiResponse,
      DeleteReleaseStructureApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/dp/${queryArg.dpId}/structure/${queryArg.structureId}`,
        method: "DELETE",
      }),
    }),
    getProviders: build.query<GetProvidersApiResponse, GetProvidersApiArg>({
      query: () => ({ url: `/v2/expectation-providers` }),
    }),
    getExpectations: build.query<
      GetExpectationsApiResponse,
      GetExpectationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/expectations`,
        params: {
          providerCode: queryArg.providerCode,
          active: queryArg.active,
        },
      }),
    }),
    getStructureDetail5: build.query<
      GetStructureDetail5ApiResponse,
      GetStructureDetail5ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/folder/${queryArg.structureId}`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateFolder: build.mutation<UpdateFolderApiResponse, UpdateFolderApiArg>({
      query: (queryArg) => ({
        url: `/v2/folder/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.folder,
      }),
    }),
    getOdcs: build.query<GetOdcsApiResponse, GetOdcsApiArg>({
      query: (queryArg) => ({ url: `/v2/folder/${queryArg.structureId}/odcs` }),
    }),
    updateOdcs: build.mutation<UpdateOdcsApiResponse, UpdateOdcsApiArg>({
      query: (queryArg) => ({
        url: `/v2/folder/${queryArg.structureId}/odcs`,
        method: "PUT",
        body: queryArg.basicData,
      }),
    }),
    setOdcsStatus: build.mutation<
      SetOdcsStatusApiResponse,
      SetOdcsStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/folder/${queryArg.structureId}/odcs/${queryArg.newStatus}`,
        method: "PUT",
      }),
    }),
    getFolderOverview: build.query<
      GetFolderOverviewApiResponse,
      GetFolderOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/folder/${queryArg.structureId}/overview`,
      }),
    }),
    updateFolderOverview: build.mutation<
      UpdateFolderOverviewApiResponse,
      UpdateFolderOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/folder/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.folderOverview,
      }),
    }),
    importStructures: build.mutation<
      ImportStructuresApiResponse,
      ImportStructuresApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/import`,
        method: "POST",
        body: queryArg.structureExportDto,
        params: {
          parentId: queryArg.parentId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    checkJson: build.mutation<CheckJsonApiResponse, CheckJsonApiArg>({
      query: (queryArg) => ({
        url: `/v2/import/check`,
        method: "POST",
        body: queryArg.structureExportDto,
        params: {
          parentId: queryArg.parentId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    getImportResult: build.query<
      GetImportResultApiResponse,
      GetImportResultApiArg
    >({
      query: (queryArg) => ({ url: `/v2/import/${queryArg.taskId}/result` }),
    }),
    getAllLovAcronym: build.query<
      GetAllLovAcronymApiResponse,
      GetAllLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovAcronym: build.mutation<
      CreateLovAcronymApiResponse,
      CreateLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym`,
        method: "POST",
        body: queryArg.acronymDto,
      }),
    }),
    deleteLovAcronym: build.mutation<
      DeleteLovAcronymApiResponse,
      DeleteLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovAcronym: build.query<GetLovAcronymApiResponse, GetLovAcronymApiArg>({
      query: (queryArg) => ({ url: `/v2/lov/acronym/${queryArg.id}` }),
    }),
    updateLovAcronym: build.mutation<
      UpdateLovAcronymApiResponse,
      UpdateLovAcronymApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/acronym/${queryArg.id}`,
        method: "PUT",
        body: queryArg.acronymDto,
      }),
    }),
    getAllLovBusinessDomain: build.query<
      GetAllLovBusinessDomainApiResponse,
      GetAllLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovBusinessDomain: build.mutation<
      CreateLovBusinessDomainApiResponse,
      CreateLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain`,
        method: "POST",
        body: queryArg.businessDomainDto,
      }),
    }),
    deleteLovBusinessDomain: build.mutation<
      DeleteLovBusinessDomainApiResponse,
      DeleteLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovBusinessDomain: build.query<
      GetLovBusinessDomainApiResponse,
      GetLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/business-domain/${queryArg.id}` }),
    }),
    updateLovBusinessDomain: build.mutation<
      UpdateLovBusinessDomainApiResponse,
      UpdateLovBusinessDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/business-domain/${queryArg.id}`,
        method: "PUT",
        body: queryArg.businessDomainDto,
      }),
    }),
    getAllLovCustomAttributeGroup: build.query<
      GetAllLovCustomAttributeGroupApiResponse,
      GetAllLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovCustomAttributeGroup: build.mutation<
      CreateLovCustomAttributeGroupApiResponse,
      CreateLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp`,
        method: "POST",
        body: queryArg.customAttributeGroupDto,
      }),
    }),
    deleteLovCustomAttributeGroup: build.mutation<
      DeleteLovCustomAttributeGroupApiResponse,
      DeleteLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovCustomAttributeGroup: build.query<
      GetLovCustomAttributeGroupApiResponse,
      GetLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/custom-attr-grp/${queryArg.id}` }),
    }),
    updateLovCustomAttributeGroup: build.mutation<
      UpdateLovCustomAttributeGroupApiResponse,
      UpdateLovCustomAttributeGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-grp/${queryArg.id}`,
        method: "PUT",
        body: queryArg.customAttributeGroupDto,
      }),
    }),
    getAllLovCustomAttributeLov: build.query<
      GetAllLovCustomAttributeLovApiResponse,
      GetAllLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov`,
        params: {
          search: queryArg.search,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovCustomAttributeLov: build.mutation<
      CreateLovCustomAttributeLovApiResponse,
      CreateLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov`,
        method: "POST",
        body: queryArg.customLovDto,
      }),
    }),
    downloadCustomLovsLovCustomAttributeLov: build.query<
      DownloadCustomLovsLovCustomAttributeLovApiResponse,
      DownloadCustomLovsLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov/export`,
        params: {
          search: queryArg.search,
        },
      }),
    }),
    deleteLovCustomAttributeLov: build.mutation<
      DeleteLovCustomAttributeLovApiResponse,
      DeleteLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovCustomAttributeLov: build.query<
      GetLovCustomAttributeLovApiResponse,
      GetLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/custom-attr-lov/${queryArg.id}` }),
    }),
    updateLovCustomAttributeLov: build.mutation<
      UpdateLovCustomAttributeLovApiResponse,
      UpdateLovCustomAttributeLovApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attr-lov/${queryArg.id}`,
        method: "PUT",
        body: queryArg.customLovDto,
      }),
    }),
    getAllLovCustomAttribute: build.query<
      GetAllLovCustomAttributeApiResponse,
      GetAllLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute`,
        params: {
          search: queryArg.search,
          structureType: queryArg.structureType,
          stereotypeId: queryArg.stereotypeId,
          stereotypeCode: queryArg.stereotypeCode,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovCustomAttribute: build.mutation<
      CreateLovCustomAttributeApiResponse,
      CreateLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute`,
        method: "POST",
        body: queryArg.customAttributeDto,
      }),
    }),
    deleteLovCustomAttribute: build.mutation<
      DeleteLovCustomAttributeApiResponse,
      DeleteLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovCustomAttribute: build.query<
      GetLovCustomAttributeApiResponse,
      GetLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/custom-attribute/${queryArg.id}` }),
    }),
    updateLovCustomAttribute: build.mutation<
      UpdateLovCustomAttributeApiResponse,
      UpdateLovCustomAttributeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/custom-attribute/${queryArg.id}`,
        method: "PUT",
        body: queryArg.customAttributeDto,
      }),
    }),
    getAllLovDomain: build.query<
      GetAllLovDomainApiResponse,
      GetAllLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain`,
        params: {
          search: queryArg.search,
          dataType: queryArg.dataType,
          technologyId: queryArg.technologyId,
          technologyCode: queryArg.technologyCode,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovDomain: build.mutation<
      CreateLovDomainApiResponse,
      CreateLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain`,
        method: "POST",
        body: queryArg.domainV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    deleteLovDomain: build.mutation<
      DeleteLovDomainApiResponse,
      DeleteLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain/${queryArg.id}`,
        method: "DELETE",
        params: {
          update: queryArg.update,
        },
      }),
    }),
    getLovDomain: build.query<GetLovDomainApiResponse, GetLovDomainApiArg>({
      query: (queryArg) => ({ url: `/v2/lov/domain/${queryArg.id}` }),
    }),
    updateLovDomain: build.mutation<
      UpdateLovDomainApiResponse,
      UpdateLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain/${queryArg.id}`,
        method: "PUT",
        body: queryArg.domainV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    computeImpactDomainChangeLovDomain: build.mutation<
      ComputeImpactDomainChangeLovDomainApiResponse,
      ComputeImpactDomainChangeLovDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/domain/${queryArg.id}/impact`,
        method: "POST",
        body: queryArg.domainUpdateDto,
      }),
    }),
    getAllLovObjectType: build.query<
      GetAllLovObjectTypeApiResponse,
      GetAllLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type`,
        params: {
          search: queryArg.search,
          structureType: queryArg.structureType,
          defaultFlag: queryArg.defaultFlag,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovObjectType: build.mutation<
      CreateLovObjectTypeApiResponse,
      CreateLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type`,
        method: "POST",
        body: queryArg.objectSettingsDto,
      }),
    }),
    deleteLovObjectType: build.mutation<
      DeleteLovObjectTypeApiResponse,
      DeleteLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovObjectType: build.query<
      GetLovObjectTypeApiResponse,
      GetLovObjectTypeApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/object-type/${queryArg.id}` }),
    }),
    updateLovObjectType: build.mutation<
      UpdateLovObjectTypeApiResponse,
      UpdateLovObjectTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/object-type/${queryArg.id}`,
        method: "PUT",
        body: queryArg.objectSettingsDto,
      }),
    }),
    getAllLovStereotype: build.query<
      GetAllLovStereotypeApiResponse,
      GetAllLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype`,
        params: {
          search: queryArg.search,
          type: queryArg["type"],
          category: queryArg.category,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovStereotype: build.mutation<
      CreateLovStereotypeApiResponse,
      CreateLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype`,
        method: "POST",
        body: queryArg.stereotypeV2Dto,
      }),
    }),
    deleteLovStereotype: build.mutation<
      DeleteLovStereotypeApiResponse,
      DeleteLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getLovStereotype: build.query<
      GetLovStereotypeApiResponse,
      GetLovStereotypeApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/stereotype/${queryArg.id}` }),
    }),
    updateLovStereotype: build.mutation<
      UpdateLovStereotypeApiResponse,
      UpdateLovStereotypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/stereotype/${queryArg.id}`,
        method: "PUT",
        body: queryArg.stereotypeV2Dto,
      }),
    }),
    getAllLovTechnicalColumn: build.query<
      GetAllLovTechnicalColumnApiResponse,
      GetAllLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column`,
        params: {
          search: queryArg.search,
          stereotypeId: queryArg.stereotypeId,
          stereotypeCode: queryArg.stereotypeCode,
          updatedBy: queryArg.updatedBy,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          direction: queryArg.direction,
        },
      }),
    }),
    createLovTechnicalColumn: build.mutation<
      CreateLovTechnicalColumnApiResponse,
      CreateLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column`,
        method: "POST",
        body: queryArg.technicalColumnV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    deleteLovTechnicalColumn: build.mutation<
      DeleteLovTechnicalColumnApiResponse,
      DeleteLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column/${queryArg.id}`,
        method: "DELETE",
        params: {
          update: queryArg.update,
        },
      }),
    }),
    getLovTechnicalColumn: build.query<
      GetLovTechnicalColumnApiResponse,
      GetLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({ url: `/v2/lov/technical-column/${queryArg.id}` }),
    }),
    updateLovTechnicalColumn: build.mutation<
      UpdateLovTechnicalColumnApiResponse,
      UpdateLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column/${queryArg.id}`,
        method: "PUT",
        body: queryArg.technicalColumnV2Dto,
        params: {
          update: queryArg.update,
        },
      }),
    }),
    computeImpactTcChangeLovTechnicalColumn: build.mutation<
      ComputeImpactTcChangeLovTechnicalColumnApiResponse,
      ComputeImpactTcChangeLovTechnicalColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technical-column/${queryArg.id}/impact`,
        method: "POST",
        body: queryArg.technicalColumnV2Dto,
      }),
    }),
    getAllLovTechnology: build.query<
      GetAllLovTechnologyApiResponse,
      GetAllLovTechnologyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lov/technology`,
        params: {
          type: queryArg["type"],
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getStructureDetail4: build.query<
      GetStructureDetail4ApiResponse,
      GetStructureDetail4ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateMapping: build.mutation<
      UpdateMappingApiResponse,
      UpdateMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.mapping,
      }),
    }),
    getMappingColumns: build.query<
      GetMappingColumnsApiResponse,
      GetMappingColumnsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/column`,
      }),
    }),
    addMappingColumn: build.mutation<
      AddMappingColumnApiResponse,
      AddMappingColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/column`,
        method: "POST",
        body: queryArg.mappingColumn,
      }),
    }),
    updateMappingColumns: build.mutation<
      UpdateMappingColumnsApiResponse,
      UpdateMappingColumnsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/column`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    updateMappingColumn1: build.mutation<
      UpdateMappingColumn1ApiResponse,
      UpdateMappingColumn1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "DELETE",
      }),
    }),
    updateMappingColumn: build.mutation<
      UpdateMappingColumnApiResponse,
      UpdateMappingColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "PUT",
        body: queryArg.mappingColumn,
      }),
    }),
    getMappingOtherScripts: build.query<
      GetMappingOtherScriptsApiResponse,
      GetMappingOtherScriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/other-scripts`,
      }),
    }),
    updateMappingOtherScripts: build.mutation<
      UpdateMappingOtherScriptsApiResponse,
      UpdateMappingOtherScriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/other-scripts`,
        method: "PUT",
        body: queryArg.mappingOtherScriptsDto,
      }),
    }),
    getMappingOverview: build.query<
      GetMappingOverviewApiResponse,
      GetMappingOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/overview`,
      }),
    }),
    updateMappingOverview: build.mutation<
      UpdateMappingOverviewApiResponse,
      UpdateMappingOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.mappingOverview,
      }),
    }),
    getMappingPermissions: build.query<
      GetMappingPermissionsApiResponse,
      GetMappingPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/permission`,
      }),
    }),
    setMappingPermission: build.mutation<
      SetMappingPermissionApiResponse,
      SetMappingPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/permission`,
        method: "POST",
        body: queryArg.mappingPermission,
      }),
    }),
    deleteMappingPermission: build.mutation<
      DeleteMappingPermissionApiResponse,
      DeleteMappingPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/permission/${queryArg.userCode}`,
        method: "DELETE",
      }),
    }),
    getMappingSources: build.query<
      GetMappingSourcesApiResponse,
      GetMappingSourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/sources`,
      }),
    }),
    addMappingSourceItem: build.mutation<
      AddMappingSourceItemApiResponse,
      AddMappingSourceItemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/sources`,
        method: "POST",
        body: queryArg.sourceItem,
      }),
    }),
    updateMappingSourceItems: build.mutation<
      UpdateMappingSourceItemsApiResponse,
      UpdateMappingSourceItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/sources`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getMappingSourcesData: build.query<
      GetMappingSourcesDataApiResponse,
      GetMappingSourcesDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/sources/data`,
      }),
    }),
    updateMappingSourcesData: build.mutation<
      UpdateMappingSourcesDataApiResponse,
      UpdateMappingSourcesDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/sources/data`,
        method: "PUT",
        body: queryArg.mappingSourcesData,
      }),
    }),
    deleteMappingSourceItem: build.mutation<
      DeleteMappingSourceItemApiResponse,
      DeleteMappingSourceItemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "DELETE",
      }),
    }),
    updateMappingSourceItem: build.mutation<
      UpdateMappingSourceItemApiResponse,
      UpdateMappingSourceItemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/mapping/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "PUT",
        body: queryArg.sourceItem,
      }),
    }),
    getSecrets: build.query<GetSecretsApiResponse, GetSecretsApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret`,
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    createSecret: build.mutation<CreateSecretApiResponse, CreateSecretApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret`,
        method: "POST",
        body: queryArg.secretDto,
      }),
    }),
    deleteSecret: build.mutation<DeleteSecretApiResponse, DeleteSecretApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret/${queryArg.secretId}`,
        method: "DELETE",
      }),
    }),
    getSecret: build.query<GetSecretApiResponse, GetSecretApiArg>({
      query: (queryArg) => ({ url: `/v2/secret/${queryArg.secretId}` }),
    }),
    updateSecret: build.mutation<UpdateSecretApiResponse, UpdateSecretApiArg>({
      query: (queryArg) => ({
        url: `/v2/secret/${queryArg.secretId}`,
        method: "PUT",
        body: queryArg.secretDto,
      }),
    }),
    getStructures: build.query<GetStructuresApiResponse, GetStructuresApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure`,
        params: {
          type: queryArg["type"],
          id: queryArg.id,
          uuid: queryArg.uuid,
          locked: queryArg.locked,
          lockedByMe: queryArg.lockedByMe,
          maxLevel: queryArg.maxLevel,
          jsonPath: queryArg.jsonPath,
          startFromId: queryArg.startFromId,
          searchTerm: queryArg.searchTerm,
          status: queryArg.status,
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
          sortBy: queryArg.sortBy,
          appendIncluded: queryArg.appendIncluded,
        },
      }),
    }),
    createSystem: build.mutation<CreateSystemApiResponse, CreateSystemApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure`,
        method: "POST",
        body: queryArg.system,
      }),
    }),
    generateScripts: build.mutation<
      GenerateScriptsApiResponse,
      GenerateScriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/generate`,
        method: "POST",
        body: queryArg.massExportExternalConfigDto,
      }),
    }),
    bulkUnlock: build.mutation<BulkUnlockApiResponse, BulkUnlockApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure/lock`,
        method: "DELETE",
        params: {
          force: queryArg.force,
          id: queryArg.id,
        },
      }),
    }),
    bulkLock: build.mutation<BulkLockApiResponse, BulkLockApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure/lock`,
        method: "POST",
        params: {
          force: queryArg.force,
          id: queryArg.id,
        },
      }),
    }),
    getDeletedStructures: build.query<
      GetDeletedStructuresApiResponse,
      GetDeletedStructuresApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/trash`,
        params: {
          search: queryArg.search,
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    undeleteStructure: build.mutation<
      UndeleteStructureApiResponse,
      UndeleteStructureApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/trash/${queryArg.structureId}/restore`,
        method: "POST",
        params: {
          newParentId: queryArg.newParentId,
        },
      }),
    }),
    getFullTree: build.query<GetFullTreeApiResponse, GetFullTreeApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure/tree`,
        params: {
          type: queryArg["type"],
          id: queryArg.id,
          uuid: queryArg.uuid,
          locked: queryArg.locked,
          lockedByMe: queryArg.lockedByMe,
          maxLevel: queryArg.maxLevel,
          jsonPath: queryArg.jsonPath,
          startFromId: queryArg.startFromId,
          searchTerm: queryArg.searchTerm,
          status: queryArg.status,
        },
      }),
    }),
    getChildren: build.query<GetChildrenApiResponse, GetChildrenApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.parentId}/children`,
        params: {
          type: queryArg["type"],
          search: queryArg.search,
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
          maxLevel: queryArg.maxLevel,
        },
      }),
    }),
    createStructure: build.mutation<
      CreateStructureApiResponse,
      CreateStructureApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.parentId}/children/${queryArg["type"]}`,
        method: "POST",
        params: {
          name: queryArg.name,
        },
      }),
    }),
    getStructureMetadata: build.query<
      GetStructureMetadataApiResponse,
      GetStructureMetadataApiArg
    >({
      query: (queryArg) => ({ url: `/v2/structure/${queryArg.structureId}` }),
    }),
    getStructureAcl: build.query<
      GetStructureAclApiResponse,
      GetStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl`,
      }),
    }),
    createStructureAcl: build.mutation<
      CreateStructureAclApiResponse,
      CreateStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl`,
        method: "POST",
        body: queryArg.aclEntryDto,
      }),
    }),
    getEffectiveAcl: build.query<
      GetEffectiveAclApiResponse,
      GetEffectiveAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/effective`,
      }),
    }),
    evaluatePermissions: build.query<
      EvaluatePermissionsApiResponse,
      EvaluatePermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/evaluate`,
        params: {
          forUserId: queryArg.forUserId,
          groupName: queryArg.groupName,
        },
      }),
    }),
    deleteStructureAcl: build.mutation<
      DeleteStructureAclApiResponse,
      DeleteStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/${queryArg.aclId}`,
        method: "DELETE",
      }),
    }),
    updateStructureAcl: build.mutation<
      UpdateStructureAclApiResponse,
      UpdateStructureAclApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/acl/${queryArg.aclId}`,
        method: "PUT",
        body: queryArg.aclEntryDto,
      }),
    }),
    asyncStructurePreview: build.mutation<
      AsyncStructurePreviewApiResponse,
      AsyncStructurePreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/async/preview`,
        method: "POST",
        params: {
          objectTypeId: queryArg.objectTypeId,
        },
      }),
    }),
    count: build.query<CountApiResponse, CountApiArg>({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/count`,
      }),
    }),
    getStructureHistory: build.query<
      GetStructureHistoryApiResponse,
      GetStructureHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/history`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    createStructureHistory: build.mutation<
      CreateStructureHistoryApiResponse,
      CreateStructureHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/history`,
        method: "POST",
        params: {
          description: queryArg.description,
          fixImpacts: queryArg.fixImpacts,
        },
      }),
    }),
    prePushValidation: build.query<
      PrePushValidationApiResponse,
      PrePushValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/history-validation`,
      }),
    }),
    getStructureHistoryWithDeployment: build.query<
      GetStructureHistoryWithDeploymentApiResponse,
      GetStructureHistoryWithDeploymentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/history/${queryArg.versionNumber}`,
      }),
    }),
    replaceStructureVersion: build.mutation<
      ReplaceStructureVersionApiResponse,
      ReplaceStructureVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/history/${queryArg.versionNumber}/restore`,
        method: "POST",
      }),
    }),
    unLockStructure: build.mutation<
      UnLockStructureApiResponse,
      UnLockStructureApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/lock`,
        method: "DELETE",
      }),
    }),
    lockStructure: build.mutation<
      LockStructureApiResponse,
      LockStructureApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/lock`,
        method: "POST",
      }),
    }),
    getParentSystem: build.query<
      GetParentSystemApiResponse,
      GetParentSystemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/system`,
      }),
    }),
    getStructureTree: build.query<
      GetStructureTreeApiResponse,
      GetStructureTreeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structure/${queryArg.structureId}/tree`,
        params: {
          type: queryArg["type"],
          id: queryArg.id,
          uuid: queryArg.uuid,
          locked: queryArg.locked,
          lockedByMe: queryArg.lockedByMe,
          maxLevel: queryArg.maxLevel,
          jsonPath: queryArg.jsonPath,
          startFromId: queryArg.startFromId,
          searchTerm: queryArg.searchTerm,
          status: queryArg.status,
        },
      }),
    }),
    getDeploymentPackages: build.query<
      GetDeploymentPackagesApiResponse,
      GetDeploymentPackagesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/deployment-package`,
        params: {
          status: queryArg.status,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    createDeploymentPackage: build.mutation<
      CreateDeploymentPackageApiResponse,
      CreateDeploymentPackageApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/deployment-package`,
        method: "POST",
        body: queryArg.releaseDto,
      }),
    }),
    getEnvGitBranches: build.query<
      GetEnvGitBranchesApiResponse,
      GetEnvGitBranchesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/${queryArg.systemId}/env/${queryArg.envCode}/git-branche`,
      }),
    }),
    getStructureDetail1: build.query<
      GetStructureDetail1ApiResponse,
      GetStructureDetail1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateTable: build.mutation<UpdateTableApiResponse, UpdateTableApiArg>({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.table,
      }),
    }),
    getTableColumns: build.query<
      GetTableColumnsApiResponse,
      GetTableColumnsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/column`,
      }),
    }),
    addTableColumn: build.mutation<
      AddTableColumnApiResponse,
      AddTableColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/column`,
        method: "POST",
        body: queryArg.tableColumn,
      }),
    }),
    updateTableColumns: build.mutation<
      UpdateTableColumnsApiResponse,
      UpdateTableColumnsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/column`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableColumn: build.mutation<
      DeleteTableColumnApiResponse,
      DeleteTableColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "DELETE",
      }),
    }),
    updateTableColumn: build.mutation<
      UpdateTableColumnApiResponse,
      UpdateTableColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "PUT",
        body: queryArg.tableColumn,
      }),
    }),
    getTableConstraints2: build.query<
      GetTableConstraints2ApiResponse,
      GetTableConstraints2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/constraint`,
      }),
    }),
    addTableConstraint2: build.mutation<
      AddTableConstraint2ApiResponse,
      AddTableConstraint2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/constraint`,
        method: "POST",
        body: queryArg.tableConstraint,
      }),
    }),
    updateTableConstraints2: build.mutation<
      UpdateTableConstraints2ApiResponse,
      UpdateTableConstraints2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/constraint`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableConstraint2: build.mutation<
      DeleteTableConstraint2ApiResponse,
      DeleteTableConstraint2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/constraint/${queryArg.constraintCode}`,
        method: "DELETE",
      }),
    }),
    updateTableConstraint2: build.mutation<
      UpdateTableConstraint2ApiResponse,
      UpdateTableConstraint2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/constraint/${queryArg.constraintCode}`,
        method: "PUT",
        body: queryArg.tableConstraint,
      }),
    }),
    getStructureDetail3: build.query<
      GetStructureDetail3ApiResponse,
      GetStructureDetail3ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateTable2: build.mutation<UpdateTable2ApiResponse, UpdateTable2ApiArg>({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history`,
        method: "PUT",
        body: queryArg.historyTable,
      }),
    }),
    getTableColumns2: build.query<
      GetTableColumns2ApiResponse,
      GetTableColumns2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/column`,
      }),
    }),
    getTableConstraints1: build.query<
      GetTableConstraints1ApiResponse,
      GetTableConstraints1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint`,
      }),
    }),
    addTableConstraint1: build.mutation<
      AddTableConstraint1ApiResponse,
      AddTableConstraint1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint`,
        method: "POST",
        body: queryArg.tableConstraint,
      }),
    }),
    updateTableConstraints1: build.mutation<
      UpdateTableConstraints1ApiResponse,
      UpdateTableConstraints1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableConstraint1: build.mutation<
      DeleteTableConstraint1ApiResponse,
      DeleteTableConstraint1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint/${queryArg.constraintCode}`,
        method: "DELETE",
      }),
    }),
    updateTableConstraint1: build.mutation<
      UpdateTableConstraint1ApiResponse,
      UpdateTableConstraint1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/constraint/${queryArg.constraintCode}`,
        method: "PUT",
        body: queryArg.tableConstraint,
      }),
    }),
    getTableIndexes2: build.query<
      GetTableIndexes2ApiResponse,
      GetTableIndexes2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index`,
      }),
    }),
    addTableIndex2: build.mutation<
      AddTableIndex2ApiResponse,
      AddTableIndex2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index`,
        method: "POST",
        body: queryArg.tableIndex,
      }),
    }),
    updateTableIndexes2: build.mutation<
      UpdateTableIndexes2ApiResponse,
      UpdateTableIndexes2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableIndex2: build.mutation<
      DeleteTableIndex2ApiResponse,
      DeleteTableIndex2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index/${queryArg.indexCode}`,
        method: "DELETE",
      }),
    }),
    updateTableIndex2: build.mutation<
      UpdateTableIndex2ApiResponse,
      UpdateTableIndex2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/index/${queryArg.indexCode}`,
        method: "PUT",
        body: queryArg.tableIndex,
      }),
    }),
    getTableOverview2: build.query<
      GetTableOverview2ApiResponse,
      GetTableOverview2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/overview`,
      }),
    }),
    updateTableOverview2: build.mutation<
      UpdateTableOverview2ApiResponse,
      UpdateTableOverview2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/overview`,
        method: "PUT",
        body: queryArg.tableOverviewPartitioningStrategyHistoryTable,
      }),
    }),
    deleteTablePermission2: build.mutation<
      DeleteTablePermission2ApiResponse,
      DeleteTablePermission2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/permission`,
        method: "DELETE",
        params: {
          userCode: queryArg.userCode,
          userName: queryArg.userName,
          userId: queryArg.userId,
        },
      }),
    }),
    getTablePermissions2: build.query<
      GetTablePermissions2ApiResponse,
      GetTablePermissions2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/permission`,
      }),
    }),
    setTablePermission2: build.mutation<
      SetTablePermission2ApiResponse,
      SetTablePermission2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/permission`,
        method: "POST",
        body: queryArg.tablePermission,
      }),
    }),
    getTableScripts2: build.query<
      GetTableScripts2ApiResponse,
      GetTableScripts2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/scripts`,
      }),
    }),
    updateTableScripts2: build.mutation<
      UpdateTableScripts2ApiResponse,
      UpdateTableScripts2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/history/scripts`,
        method: "PUT",
        body: queryArg.tableScripts,
      }),
    }),
    getTableIndexes1: build.query<
      GetTableIndexes1ApiResponse,
      GetTableIndexes1ApiArg
    >({
      query: (queryArg) => ({ url: `/v2/table/${queryArg.structureId}/index` }),
    }),
    addTableIndex1: build.mutation<
      AddTableIndex1ApiResponse,
      AddTableIndex1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/index`,
        method: "POST",
        body: queryArg.tableIndex,
      }),
    }),
    updateTableIndexes1: build.mutation<
      UpdateTableIndexes1ApiResponse,
      UpdateTableIndexes1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/index`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableIndex1: build.mutation<
      DeleteTableIndex1ApiResponse,
      DeleteTableIndex1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/index/${queryArg.indexCode}`,
        method: "DELETE",
      }),
    }),
    updateTableIndex1: build.mutation<
      UpdateTableIndex1ApiResponse,
      UpdateTableIndex1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/index/${queryArg.indexCode}`,
        method: "PUT",
        body: queryArg.tableIndex,
      }),
    }),
    getTableOverview1: build.query<
      GetTableOverview1ApiResponse,
      GetTableOverview1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/overview`,
      }),
    }),
    updateTableOverview1: build.mutation<
      UpdateTableOverview1ApiResponse,
      UpdateTableOverview1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.tableOverviewPartitioningStrategyTable,
      }),
    }),
    deleteTablePermission1: build.mutation<
      DeleteTablePermission1ApiResponse,
      DeleteTablePermission1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/permission`,
        method: "DELETE",
        params: {
          userCode: queryArg.userCode,
          userName: queryArg.userName,
          userId: queryArg.userId,
        },
      }),
    }),
    getTablePermissions1: build.query<
      GetTablePermissions1ApiResponse,
      GetTablePermissions1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/permission`,
      }),
    }),
    setTablePermission1: build.mutation<
      SetTablePermission1ApiResponse,
      SetTablePermission1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/permission`,
        method: "POST",
        body: queryArg.tablePermission,
      }),
    }),
    getStructureDetail2: build.query<
      GetStructureDetail2ApiResponse,
      GetStructureDetail2ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateTable1: build.mutation<UpdateTable1ApiResponse, UpdateTable1ApiArg>({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference`,
        method: "PUT",
        body: queryArg.referenceTable,
      }),
    }),
    getTableColumns1: build.query<
      GetTableColumns1ApiResponse,
      GetTableColumns1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/column`,
      }),
    }),
    getTableConstraints: build.query<
      GetTableConstraintsApiResponse,
      GetTableConstraintsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint`,
      }),
    }),
    addTableConstraint: build.mutation<
      AddTableConstraintApiResponse,
      AddTableConstraintApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint`,
        method: "POST",
        body: queryArg.tableConstraint,
      }),
    }),
    updateTableConstraints: build.mutation<
      UpdateTableConstraintsApiResponse,
      UpdateTableConstraintsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableConstraint: build.mutation<
      DeleteTableConstraintApiResponse,
      DeleteTableConstraintApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint/${queryArg.constraintCode}`,
        method: "DELETE",
      }),
    }),
    updateTableConstraint: build.mutation<
      UpdateTableConstraintApiResponse,
      UpdateTableConstraintApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/constraint/${queryArg.constraintCode}`,
        method: "PUT",
        body: queryArg.tableConstraint,
      }),
    }),
    getTableIndexes: build.query<
      GetTableIndexesApiResponse,
      GetTableIndexesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index`,
      }),
    }),
    addTableIndex: build.mutation<
      AddTableIndexApiResponse,
      AddTableIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index`,
        method: "POST",
        body: queryArg.tableIndex,
      }),
    }),
    updateTableIndexes: build.mutation<
      UpdateTableIndexesApiResponse,
      UpdateTableIndexesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTableIndex: build.mutation<
      DeleteTableIndexApiResponse,
      DeleteTableIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index/${queryArg.indexCode}`,
        method: "DELETE",
      }),
    }),
    updateTableIndex: build.mutation<
      UpdateTableIndexApiResponse,
      UpdateTableIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/index/${queryArg.indexCode}`,
        method: "PUT",
        body: queryArg.tableIndex,
      }),
    }),
    getTableOverview: build.query<
      GetTableOverviewApiResponse,
      GetTableOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/overview`,
      }),
    }),
    updateTableOverview: build.mutation<
      UpdateTableOverviewApiResponse,
      UpdateTableOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/overview`,
        method: "PUT",
        body: queryArg.tableOverviewPartitioningStrategyTable,
      }),
    }),
    deleteTablePermission: build.mutation<
      DeleteTablePermissionApiResponse,
      DeleteTablePermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/permission`,
        method: "DELETE",
        params: {
          userCode: queryArg.userCode,
          userName: queryArg.userName,
          userId: queryArg.userId,
        },
      }),
    }),
    getTablePermissions: build.query<
      GetTablePermissionsApiResponse,
      GetTablePermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/permission`,
      }),
    }),
    setTablePermission: build.mutation<
      SetTablePermissionApiResponse,
      SetTablePermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/permission`,
        method: "POST",
        body: queryArg.tablePermission,
      }),
    }),
    getTableScripts1: build.query<
      GetTableScripts1ApiResponse,
      GetTableScripts1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/scripts`,
      }),
    }),
    updateTableScripts1: build.mutation<
      UpdateTableScripts1ApiResponse,
      UpdateTableScripts1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/reference/scripts`,
        method: "PUT",
        body: queryArg.tableScripts,
      }),
    }),
    getTableScripts: build.query<
      GetTableScriptsApiResponse,
      GetTableScriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/scripts`,
      }),
    }),
    updateTableScripts: build.mutation<
      UpdateTableScriptsApiResponse,
      UpdateTableScriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/table/${queryArg.structureId}/scripts`,
        method: "PUT",
        body: queryArg.tableScripts,
      }),
    }),
    getAllTemplates: build.query<
      GetAllTemplatesApiResponse,
      GetAllTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates`,
        params: {
          technologyId: queryArg.technologyId,
          stereotypeId: queryArg.stereotypeId,
        },
      }),
    }),
    createTemplate: build.mutation<
      CreateTemplateApiResponse,
      CreateTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates`,
        method: "POST",
        body: queryArg.templateDto,
      }),
    }),
    deleteTemplate: build.mutation<
      DeleteTemplateApiResponse,
      DeleteTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getTemplate: build.query<GetTemplateApiResponse, GetTemplateApiArg>({
      query: (queryArg) => ({ url: `/v2/templates/${queryArg.id}` }),
    }),
    updateTemplate: build.mutation<
      UpdateTemplateApiResponse,
      UpdateTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.id}`,
        method: "PUT",
        body: queryArg.templateDto,
      }),
    }),
    getTemplateHistory: build.query<
      GetTemplateHistoryApiResponse,
      GetTemplateHistoryApiArg
    >({
      query: (queryArg) => ({ url: `/v2/templates/${queryArg.id}/history` }),
    }),
    getTemplateHistoryDetail: build.query<
      GetTemplateHistoryDetailApiResponse,
      GetTemplateHistoryDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.id}/history/${queryArg.version}`,
      }),
    }),
    postTemplateLock: build.mutation<
      PostTemplateLockApiResponse,
      PostTemplateLockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.templateId}/lock`,
        method: "POST",
      }),
    }),
    postTemplatePush: build.mutation<
      PostTemplatePushApiResponse,
      PostTemplatePushApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.templateId}/push`,
        method: "POST",
        params: {
          unlock: queryArg.unlock,
        },
      }),
    }),
    postTemplateUnlock: build.mutation<
      PostTemplateUnlockApiResponse,
      PostTemplateUnlockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/templates/${queryArg.templateId}/unlock`,
        method: "POST",
      }),
    }),
    getTenant: build.query<GetTenantApiResponse, GetTenantApiArg>({
      query: () => ({ url: `/v2/tenant` }),
    }),
    updateTenant: build.mutation<UpdateTenantApiResponse, UpdateTenantApiArg>({
      query: (queryArg) => ({
        url: `/v2/tenant`,
        method: "PUT",
        body: queryArg.tenantDto,
      }),
    }),
    getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
      query: (queryArg) => ({
        url: `/v2/user`,
        params: {
          search: queryArg.search,
          type: queryArg["type"],
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    addUser: build.mutation<AddUserApiResponse, AddUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user`,
        method: "POST",
        body: queryArg.userDto,
        params: {
          password: queryArg.password,
        },
      }),
    }),
    getApiUsers: build.query<GetApiUsersApiResponse, GetApiUsersApiArg>({
      query: () => ({ url: `/v2/user/api` }),
    }),
    addApiUser: build.mutation<AddApiUserApiResponse, AddApiUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/api`,
        method: "POST",
        body: queryArg.apiUserDto,
      }),
    }),
    deleteApiUser: build.mutation<
      DeleteApiUserApiResponse,
      DeleteApiUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/api/${queryArg.clientId}`,
        method: "DELETE",
      }),
    }),
    apiUserUpdate: build.mutation<
      ApiUserUpdateApiResponse,
      ApiUserUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/api/${queryArg.clientId}`,
        method: "POST",
        body: queryArg.apiUserDto,
      }),
    }),
    apiUserResetSecret: build.mutation<
      ApiUserResetSecretApiResponse,
      ApiUserResetSecretApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/api/${queryArg.clientId}/reset-secret`,
        method: "POST",
      }),
    }),
    getSessionContext: build.query<
      GetSessionContextApiResponse,
      GetSessionContextApiArg
    >({
      query: () => ({ url: `/v2/user/context` }),
    }),
    updateSessionContext: build.mutation<
      UpdateSessionContextApiResponse,
      UpdateSessionContextApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/context`,
        method: "PUT",
        body: queryArg.sessionContextDto,
      }),
    }),
    getGroups: build.query<GetGroupsApiResponse, GetGroupsApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group`,
        params: {
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    createGroup: build.mutation<CreateGroupApiResponse, CreateGroupApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group`,
        method: "POST",
        body: queryArg.groupDto,
      }),
    }),
    deleteGroup: build.mutation<DeleteGroupApiResponse, DeleteGroupApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}`,
        method: "DELETE",
      }),
    }),
    updateGroup: build.mutation<UpdateGroupApiResponse, UpdateGroupApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}`,
        method: "PUT",
        body: queryArg.groupDto,
      }),
    }),
    getRolesForGroup: build.query<
      GetRolesForGroupApiResponse,
      GetRolesForGroupApiArg
    >({
      query: (queryArg) => ({ url: `/v2/user/group/${queryArg.groupId}/role` }),
    }),
    setRolesForGroup: build.mutation<
      SetRolesForGroupApiResponse,
      SetRolesForGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/role`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    removeUserFromGroup: build.mutation<
      RemoveUserFromGroupApiResponse,
      RemoveUserFromGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/user`,
        method: "DELETE",
        params: {
          userId: queryArg.userId,
        },
      }),
    }),
    getUsersInGroup: build.query<
      GetUsersInGroupApiResponse,
      GetUsersInGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/user`,
        params: {
          pageSize: queryArg.pageSize,
          pageNumber: queryArg.pageNumber,
        },
      }),
    }),
    addUserToGroup: build.mutation<
      AddUserToGroupApiResponse,
      AddUserToGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/group/${queryArg.groupId}/user`,
        method: "POST",
        params: {
          userId: queryArg.userId,
        },
      }),
    }),
    getUserList: build.query<GetUserListApiResponse, GetUserListApiArg>({
      query: () => ({ url: `/v2/user/list` }),
    }),
    deleteUser: build.mutation<DeleteUserApiResponse, DeleteUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getUser: build.query<GetUserApiResponse, GetUserApiArg>({
      query: (queryArg) => ({ url: `/v2/user/${queryArg.userId}` }),
    }),
    editUser: build.mutation<EditUserApiResponse, EditUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.userDto,
      }),
    }),
    getUserGroups: build.query<GetUserGroupsApiResponse, GetUserGroupsApiArg>({
      query: (queryArg) => ({ url: `/v2/user/${queryArg.userId}/group` }),
    }),
    unLockUser: build.mutation<UnLockUserApiResponse, UnLockUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/lock`,
        method: "DELETE",
      }),
    }),
    lockUser: build.mutation<LockUserApiResponse, LockUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/lock`,
        method: "POST",
      }),
    }),
    resetPassword: build.mutation<
      ResetPasswordApiResponse,
      ResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/reset-password`,
        method: "POST",
      }),
    }),
    getRolesForUser: build.query<
      GetRolesForUserApiResponse,
      GetRolesForUserApiArg
    >({
      query: (queryArg) => ({ url: `/v2/user/${queryArg.userId}/role` }),
    }),
    setRolesForUser: build.mutation<
      SetRolesForUserApiResponse,
      SetRolesForUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user/${queryArg.userId}/role`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getStructureDetail: build.query<
      GetStructureDetailApiResponse,
      GetStructureDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    updateView: build.mutation<UpdateViewApiResponse, UpdateViewApiArg>({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}`,
        method: "PUT",
        body: queryArg.view,
      }),
    }),
    getViewColumns: build.query<
      GetViewColumnsApiResponse,
      GetViewColumnsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/view/${queryArg.structureId}/column` }),
    }),
    addViewColumn: build.mutation<
      AddViewColumnApiResponse,
      AddViewColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/column`,
        method: "POST",
        body: queryArg.viewColumn,
      }),
    }),
    updateViewColumns: build.mutation<
      UpdateViewColumnsApiResponse,
      UpdateViewColumnsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/column`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    updateViewColumn1: build.mutation<
      UpdateViewColumn1ApiResponse,
      UpdateViewColumn1ApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "DELETE",
      }),
    }),
    updateViewColumn: build.mutation<
      UpdateViewColumnApiResponse,
      UpdateViewColumnApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/column/${queryArg.columnId}`,
        method: "PUT",
        body: queryArg.viewColumn,
      }),
    }),
    getViewOverview: build.query<
      GetViewOverviewApiResponse,
      GetViewOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/overview`,
      }),
    }),
    updateViewOverview: build.mutation<
      UpdateViewOverviewApiResponse,
      UpdateViewOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/overview`,
        method: "PUT",
        body: queryArg.viewOverview,
      }),
    }),
    getViewPermissions: build.query<
      GetViewPermissionsApiResponse,
      GetViewPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/permission`,
      }),
    }),
    setViewPermission: build.mutation<
      SetViewPermissionApiResponse,
      SetViewPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/permission`,
        method: "POST",
        body: queryArg.viewPermission,
      }),
    }),
    deleteViewPermission: build.mutation<
      DeleteViewPermissionApiResponse,
      DeleteViewPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/permission/${queryArg.userCode}`,
        method: "DELETE",
      }),
    }),
    getViewSources: build.query<
      GetViewSourcesApiResponse,
      GetViewSourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/sources`,
      }),
    }),
    addViewSourceItem: build.mutation<
      AddViewSourceItemApiResponse,
      AddViewSourceItemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/sources`,
        method: "POST",
        body: queryArg.sourceItem,
      }),
    }),
    updateViewSourceItems: build.mutation<
      UpdateViewSourceItemsApiResponse,
      UpdateViewSourceItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/sources`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getViewSourcesData: build.query<
      GetViewSourcesDataApiResponse,
      GetViewSourcesDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/sources/data`,
      }),
    }),
    updateViewSourcesData: build.mutation<
      UpdateViewSourcesDataApiResponse,
      UpdateViewSourcesDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/sources/data`,
        method: "PUT",
        body: queryArg.viewSourcesData,
      }),
    }),
    deleteViewSourceItem: build.mutation<
      DeleteViewSourceItemApiResponse,
      DeleteViewSourceItemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "DELETE",
      }),
    }),
    updateViewSourceItem: build.mutation<
      UpdateViewSourceItemApiResponse,
      UpdateViewSourceItemApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/view/${queryArg.structureId}/sources/${queryArg.sourceItemId}`,
        method: "PUT",
        body: queryArg.sourceItem,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as mddApiSliceGeneratedV2 };
export type GetProvidersAdminApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead[];
export type GetProvidersAdminApiArg = void;
export type CreateProviderAdminApiResponse =
  /** status 201 Created */ ExpectationProviderDtoRead;
export type CreateProviderAdminApiArg = {
  expectationProviderDto: ExpectationProviderDto;
};
export type DeleteProviderAdminApiResponse = unknown;
export type DeleteProviderAdminApiArg = {
  providerId: number;
};
export type GetProviderAdminApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead;
export type GetProviderAdminApiArg = {
  providerId: number;
};
export type UpdateProviderAdminApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead;
export type UpdateProviderAdminApiArg = {
  providerId: number;
  expectationProviderDto: ExpectationProviderDto;
};
export type GetExpectationsAdminApiResponse =
  /** status 200 OK */ ExpectationAdminDtoRead[];
export type GetExpectationsAdminApiArg = {
  /** Provider code */
  providerCode?: string;
};
export type CreateExpectationAdminApiResponse =
  /** status 201 Created */ ExpectationAdminDtoRead;
export type CreateExpectationAdminApiArg = {
  expectationAdminDto: ExpectationAdminDto;
};
export type DeleteExpectationAdminApiResponse = unknown;
export type DeleteExpectationAdminApiArg = {
  expectationId: number;
};
export type GetExpectationAdminApiResponse =
  /** status 200 OK */ ExpectationAdminDtoRead;
export type GetExpectationAdminApiArg = {
  expectationId: number;
};
export type UpdateExpectationAdminApiResponse =
  /** status 200 OK */ ExpectationAdminDtoRead;
export type UpdateExpectationAdminApiArg = {
  expectationId: number;
  expectationAdminDto: ExpectationAdminDto;
};
export type GetDataForDiagramApiResponse =
  /** status 200 OK */ DiagramDataResponseRead;
export type GetDataForDiagramApiArg = {
  tableIds: number[];
};
export type GetDiagramByIdApiResponse = /** status 200 OK */ NewDiagram;
export type GetDiagramByIdApiArg = {
  structureId: number;
  version?: number;
};
export type UpdateDiagramApiResponse = unknown;
export type UpdateDiagramApiArg = {
  structureId: number;
  newDiagram: NewDiagram;
};
export type GetDiagramDataApiResponse = /** status 200 OK */ Diagram;
export type GetDiagramDataApiArg = {
  structureId: number;
};
export type UpdateDiagramDataApiResponse = /** status 200 OK */ Diagram;
export type UpdateDiagramDataApiArg = {
  structureId: number;
  diagram: Diagram;
};
export type GetDiagramOverviewApiResponse =
  /** status 200 OK */ DiagramOverviewRead;
export type GetDiagramOverviewApiArg = {
  structureId: number;
};
export type UpdateDiagramOverviewApiResponse =
  /** status 200 OK */ DiagramOverviewRead;
export type UpdateDiagramOverviewApiArg = {
  structureId: number;
  diagramOverview: DiagramOverview;
};
export type GetDiagramSvgApiResponse = unknown;
export type GetDiagramSvgApiArg = {
  structureId: number;
};
export type UpdateDiagramSvgApiResponse = unknown;
export type UpdateDiagramSvgApiArg = {
  structureId: number;
  body: string;
};
export type DeleteSystemReleaseApiResponse = unknown;
export type DeleteSystemReleaseApiArg = {
  dpId: number;
};
export type GetSystemReleaseApiResponse = /** status 200 OK */ ReleaseDtoRead;
export type GetSystemReleaseApiArg = {
  dpId: number;
};
export type UpdateSystemReleaseApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type UpdateSystemReleaseApiArg = {
  dpId: number;
  releaseDto: ReleaseDtoWrite;
};
export type GetReleaseEnvironmentsApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto[];
export type GetReleaseEnvironmentsApiArg = {
  dpId: number;
};
export type CreateReleaseEnvironmentApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto;
export type CreateReleaseEnvironmentApiArg = {
  dpId: number;
  releaseEnvironmentDto: ReleaseEnvironmentDto;
};
export type DeleteReleaseEnvironmentApiResponse = unknown;
export type DeleteReleaseEnvironmentApiArg = {
  dpId: number;
  envCode: string;
};
export type UpdateReleaseEnvironmentApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto;
export type UpdateReleaseEnvironmentApiArg = {
  dpId: number;
  envCode: string;
  releaseEnvironmentDto: ReleaseEnvironmentDto;
};
export type PushReleaseToGitApiResponse = unknown;
export type PushReleaseToGitApiArg = {
  dpId: number;
  envCode: string;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type CreateReleasePreviewApiResponse = /** status 200 OK */ string;
export type CreateReleasePreviewApiArg = {
  dpId: number;
  envCode: string;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type CreateReleaseScriptsApiResponse = /** status 200 OK */ string;
export type CreateReleaseScriptsApiArg = {
  dpId: number;
  envCode: string;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type CreateDeploymentsApiResponse = unknown;
export type CreateDeploymentsApiArg = {
  dpId: number;
  envCode: string;
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type GetObjectSettingsApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead[];
export type GetObjectSettingsApiArg = {
  dpId: number;
};
export type ChangeReleaseStatusApiResponse = unknown;
export type ChangeReleaseStatusApiArg = {
  dpId: number;
  newStatus: ReleaseStatusEnum;
};
export type GetReleaseStructuresApiResponse =
  /** status 200 OK */ PageWrapperStructureReleaseInfoDto;
export type GetReleaseStructuresApiArg = {
  dpId: number;
  page?: number;
  pageSize?: number;
};
export type AddStructureToReleaseApiResponse = unknown;
export type AddStructureToReleaseApiArg = {
  dpId: number;
  body: number[];
};
export type DeleteReleaseStructureApiResponse = unknown;
export type DeleteReleaseStructureApiArg = {
  dpId: number;
  structureId: number;
};
export type GetProvidersApiResponse =
  /** status 200 OK */ ExpectationProviderDtoRead[];
export type GetProvidersApiArg = void;
export type GetExpectationsApiResponse = /** status 200 OK */ ExpectationDto[];
export type GetExpectationsApiArg = {
  /** Provider code */
  providerCode?: string;
  /** When true returns only active expectations */
  active?: boolean;
};
export type GetStructureDetail5ApiResponse = /** status 200 OK */ Folder;
export type GetStructureDetail5ApiArg = {
  structureId: number;
  version?: number;
};
export type UpdateFolderApiResponse = unknown;
export type UpdateFolderApiArg = {
  structureId: number;
  folder: Folder;
};
export type GetOdcsApiResponse = /** status 200 OK */ BasicData;
export type GetOdcsApiArg = {
  structureId: number;
};
export type UpdateOdcsApiResponse = /** status 200 OK */ BasicData;
export type UpdateOdcsApiArg = {
  structureId: number;
  basicData: BasicData;
};
export type SetOdcsStatusApiResponse = unknown;
export type SetOdcsStatusApiArg = {
  structureId: number;
  newStatus: StatusEnum;
};
export type GetFolderOverviewApiResponse =
  /** status 200 OK */ FolderOverviewRead;
export type GetFolderOverviewApiArg = {
  structureId: number;
};
export type UpdateFolderOverviewApiResponse =
  /** status 200 OK */ FolderOverviewRead;
export type UpdateFolderOverviewApiArg = {
  structureId: number;
  folderOverview: FolderOverview;
};
export type ImportStructuresApiResponse =
  /** status 200 OK */ AsyncTaskExecutionDto;
export type ImportStructuresApiArg = {
  parentId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  structureExportDto: StructureExportDto;
};
export type CheckJsonApiResponse = /** status 200 OK */ CheckResult;
export type CheckJsonApiArg = {
  parentId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  structureExportDto: StructureExportDto;
};
export type GetImportResultApiResponse = /** status 200 OK */ Structure[];
export type GetImportResultApiArg = {
  taskId: number;
};
export type GetAllLovAcronymApiResponse =
  /** status 200 OK */ PageWrapperAcronymDtoRead;
export type GetAllLovAcronymApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovAcronymApiResponse = /** status 200 OK */ AcronymDtoRead;
export type CreateLovAcronymApiArg = {
  acronymDto: AcronymDto;
};
export type DeleteLovAcronymApiResponse = unknown;
export type DeleteLovAcronymApiArg = {
  id: number;
};
export type GetLovAcronymApiResponse = /** status 200 OK */ AcronymDtoRead;
export type GetLovAcronymApiArg = {
  id: number;
};
export type UpdateLovAcronymApiResponse = /** status 200 OK */ AcronymDtoRead;
export type UpdateLovAcronymApiArg = {
  id: number;
  acronymDto: AcronymDto;
};
export type GetAllLovBusinessDomainApiResponse =
  /** status 200 OK */ PageWrapperBusinessDomainDtoRead;
export type GetAllLovBusinessDomainApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovBusinessDomainApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type CreateLovBusinessDomainApiArg = {
  businessDomainDto: BusinessDomainDto;
};
export type DeleteLovBusinessDomainApiResponse = unknown;
export type DeleteLovBusinessDomainApiArg = {
  id: number;
};
export type GetLovBusinessDomainApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type GetLovBusinessDomainApiArg = {
  id: number;
};
export type UpdateLovBusinessDomainApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type UpdateLovBusinessDomainApiArg = {
  id: number;
  businessDomainDto: BusinessDomainDto;
};
export type GetAllLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ PageWrapperCustomAttributeGroupDtoRead;
export type GetAllLovCustomAttributeGroupApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ CustomAttributeGroupDtoRead;
export type CreateLovCustomAttributeGroupApiArg = {
  customAttributeGroupDto: CustomAttributeGroupDto;
};
export type DeleteLovCustomAttributeGroupApiResponse = unknown;
export type DeleteLovCustomAttributeGroupApiArg = {
  id: number;
};
export type GetLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ CustomAttributeGroupDtoRead;
export type GetLovCustomAttributeGroupApiArg = {
  id: number;
};
export type UpdateLovCustomAttributeGroupApiResponse =
  /** status 200 OK */ CustomAttributeGroupDtoRead;
export type UpdateLovCustomAttributeGroupApiArg = {
  id: number;
  customAttributeGroupDto: CustomAttributeGroupDto;
};
export type GetAllLovCustomAttributeLovApiResponse =
  /** status 200 OK */ PageWrapperCustomLovDtoRead;
export type GetAllLovCustomAttributeLovApiArg = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovCustomAttributeLovApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type CreateLovCustomAttributeLovApiArg = {
  customLovDto: CustomLovDto;
};
export type DownloadCustomLovsLovCustomAttributeLovApiResponse =
  /** status 200 OK */ string;
export type DownloadCustomLovsLovCustomAttributeLovApiArg = {
  search?: string;
};
export type DeleteLovCustomAttributeLovApiResponse = unknown;
export type DeleteLovCustomAttributeLovApiArg = {
  id: number;
};
export type GetLovCustomAttributeLovApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type GetLovCustomAttributeLovApiArg = {
  id: number;
};
export type UpdateLovCustomAttributeLovApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type UpdateLovCustomAttributeLovApiArg = {
  id: number;
  customLovDto: CustomLovDto;
};
export type GetAllLovCustomAttributeApiResponse =
  /** status 200 OK */ PageWrapperCustomAttributeDtoRead;
export type GetAllLovCustomAttributeApiArg = {
  search?: string;
  structureType?: CustomAttributeStructureTypeEnum;
  stereotypeId?: number;
  stereotypeCode?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovCustomAttributeApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type CreateLovCustomAttributeApiArg = {
  customAttributeDto: CustomAttributeDto;
};
export type DeleteLovCustomAttributeApiResponse = unknown;
export type DeleteLovCustomAttributeApiArg = {
  id: number;
};
export type GetLovCustomAttributeApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type GetLovCustomAttributeApiArg = {
  id: number;
};
export type UpdateLovCustomAttributeApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type UpdateLovCustomAttributeApiArg = {
  id: number;
  customAttributeDto: CustomAttributeDto;
};
export type GetAllLovDomainApiResponse =
  /** status 200 OK */ PageWrapperDomainV2DtoRead;
export type GetAllLovDomainApiArg = {
  search?: string;
  dataType?: DataTypeEnum;
  technologyId?: number;
  technologyCode?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovDomainApiResponse = /** status 200 OK */ DomainV2DtoRead;
export type CreateLovDomainApiArg = {
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  domainV2Dto: DomainV2Dto;
};
export type DeleteLovDomainApiResponse = unknown;
export type DeleteLovDomainApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
};
export type GetLovDomainApiResponse = /** status 200 OK */ DomainV2DtoRead;
export type GetLovDomainApiArg = {
  id: number;
};
export type UpdateLovDomainApiResponse = /** status 200 OK */ DomainV2DtoRead;
export type UpdateLovDomainApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  domainV2Dto: DomainV2Dto;
};
export type ComputeImpactDomainChangeLovDomainApiResponse =
  /** status 200 OK */ ImpactChangeCodeListDto;
export type ComputeImpactDomainChangeLovDomainApiArg = {
  /** Domain id */
  id: number;
  domainUpdateDto: DomainUpdateDto;
};
export type GetAllLovObjectTypeApiResponse =
  /** status 200 OK */ PageWrapperObjectSettingsDtoRead;
export type GetAllLovObjectTypeApiArg = {
  search?: string;
  structureType?: StructureType;
  defaultFlag?: boolean;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovObjectTypeApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead;
export type CreateLovObjectTypeApiArg = {
  objectSettingsDto: ObjectSettingsDto;
};
export type DeleteLovObjectTypeApiResponse = unknown;
export type DeleteLovObjectTypeApiArg = {
  id: number;
};
export type GetLovObjectTypeApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead;
export type GetLovObjectTypeApiArg = {
  id: number;
};
export type UpdateLovObjectTypeApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead;
export type UpdateLovObjectTypeApiArg = {
  id: number;
  objectSettingsDto: ObjectSettingsDto;
};
export type GetAllLovStereotypeApiResponse =
  /** status 200 OK */ PageWrapperStereotypeV2DtoRead;
export type GetAllLovStereotypeApiArg = {
  search?: string;
  type?: StereotypeType[];
  category?: StereotypeCategory;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovStereotypeApiResponse =
  /** status 200 OK */ StereotypeV2DtoRead;
export type CreateLovStereotypeApiArg = {
  stereotypeV2Dto: StereotypeV2Dto;
};
export type DeleteLovStereotypeApiResponse = unknown;
export type DeleteLovStereotypeApiArg = {
  id: number;
};
export type GetLovStereotypeApiResponse =
  /** status 200 OK */ StereotypeV2DtoRead;
export type GetLovStereotypeApiArg = {
  id: number;
};
export type UpdateLovStereotypeApiResponse =
  /** status 200 OK */ StereotypeV2DtoRead;
export type UpdateLovStereotypeApiArg = {
  id: number;
  stereotypeV2Dto: StereotypeV2Dto;
};
export type GetAllLovTechnicalColumnApiResponse =
  /** status 200 OK */ PageWrapperTechnicalColumnV2DtoRead;
export type GetAllLovTechnicalColumnApiArg = {
  search?: string;
  stereotypeId?: number;
  stereotypeCode?: string;
  updatedBy?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string[];
  direction?: Direction;
};
export type CreateLovTechnicalColumnApiResponse =
  /** status 200 OK */ TechnicalColumnV2DtoRead;
export type CreateLovTechnicalColumnApiArg = {
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  technicalColumnV2Dto: TechnicalColumnV2Dto;
};
export type DeleteLovTechnicalColumnApiResponse = unknown;
export type DeleteLovTechnicalColumnApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
};
export type GetLovTechnicalColumnApiResponse =
  /** status 200 OK */ TechnicalColumnV2DtoRead;
export type GetLovTechnicalColumnApiArg = {
  id: number;
};
export type UpdateLovTechnicalColumnApiResponse =
  /** status 200 OK */ TechnicalColumnV2DtoRead;
export type UpdateLovTechnicalColumnApiArg = {
  id: number;
  /** Indicates whether to update the elements or not. If true, the elements will be updated; if false, they will not be updated. */
  update?: boolean;
  technicalColumnV2Dto: TechnicalColumnV2Dto;
};
export type ComputeImpactTcChangeLovTechnicalColumnApiResponse =
  /** status 200 OK */ ImpactChangeCodeListDto;
export type ComputeImpactTcChangeLovTechnicalColumnApiArg = {
  /** Technical column id */
  id: number;
  technicalColumnV2Dto: TechnicalColumnV2Dto;
};
export type GetAllLovTechnologyApiResponse =
  /** status 200 OK */ PageWrapperTechnologyV2DtoRead;
export type GetAllLovTechnologyApiArg = {
  type?: TechnologyType;
  pageNumber?: number;
  pageSize?: number;
};
export type GetStructureDetail4ApiResponse = /** status 200 OK */ Mapping;
export type GetStructureDetail4ApiArg = {
  structureId: number;
  version?: number;
};
export type UpdateMappingApiResponse = unknown;
export type UpdateMappingApiArg = {
  structureId: number;
  mapping: Mapping;
};
export type GetMappingColumnsApiResponse = /** status 200 OK */ MappingColumn[];
export type GetMappingColumnsApiArg = {
  structureId: number;
};
export type AddMappingColumnApiResponse = /** status 200 OK */ MappingColumn;
export type AddMappingColumnApiArg = {
  structureId: number;
  mappingColumn: MappingColumn;
};
export type UpdateMappingColumnsApiResponse =
  /** status 200 OK */ MappingColumn[];
export type UpdateMappingColumnsApiArg = {
  structureId: number;
  body: MappingColumn[];
};
export type UpdateMappingColumn1ApiResponse = unknown;
export type UpdateMappingColumn1ApiArg = {
  structureId: number;
  columnId: string;
};
export type UpdateMappingColumnApiResponse = /** status 200 OK */ MappingColumn;
export type UpdateMappingColumnApiArg = {
  structureId: number;
  columnId: string;
  mappingColumn: MappingColumn;
};
export type GetMappingOtherScriptsApiResponse =
  /** status 200 OK */ MappingOtherScriptsDto;
export type GetMappingOtherScriptsApiArg = {
  structureId: number;
};
export type UpdateMappingOtherScriptsApiResponse = unknown;
export type UpdateMappingOtherScriptsApiArg = {
  structureId: number;
  mappingOtherScriptsDto: MappingOtherScriptsDto;
};
export type GetMappingOverviewApiResponse =
  /** status 200 OK */ MappingOverviewRead;
export type GetMappingOverviewApiArg = {
  structureId: number;
};
export type UpdateMappingOverviewApiResponse =
  /** status 200 OK */ MappingOverviewRead;
export type UpdateMappingOverviewApiArg = {
  structureId: number;
  mappingOverview: MappingOverview;
};
export type GetMappingPermissionsApiResponse =
  /** status 200 OK */ MappingPermission[];
export type GetMappingPermissionsApiArg = {
  structureId: number;
};
export type SetMappingPermissionApiResponse =
  /** status 200 OK */ MappingPermission;
export type SetMappingPermissionApiArg = {
  structureId: number;
  mappingPermission: MappingPermission;
};
export type DeleteMappingPermissionApiResponse = unknown;
export type DeleteMappingPermissionApiArg = {
  structureId: number;
  userCode: string;
};
export type GetMappingSourcesApiResponse = /** status 200 OK */ SourceItem[];
export type GetMappingSourcesApiArg = {
  structureId: number;
};
export type AddMappingSourceItemApiResponse = /** status 200 OK */ SourceItem;
export type AddMappingSourceItemApiArg = {
  structureId: number;
  sourceItem: SourceItem;
};
export type UpdateMappingSourceItemsApiResponse =
  /** status 200 OK */ SourceItem[];
export type UpdateMappingSourceItemsApiArg = {
  structureId: number;
  body: SourceItem[];
};
export type GetMappingSourcesDataApiResponse =
  /** status 200 OK */ MappingSourcesData;
export type GetMappingSourcesDataApiArg = {
  structureId: number;
};
export type UpdateMappingSourcesDataApiResponse = unknown;
export type UpdateMappingSourcesDataApiArg = {
  structureId: number;
  mappingSourcesData: MappingSourcesData;
};
export type DeleteMappingSourceItemApiResponse = unknown;
export type DeleteMappingSourceItemApiArg = {
  structureId: number;
  sourceItemId: string;
};
export type UpdateMappingSourceItemApiResponse =
  /** status 200 OK */ SourceItem;
export type UpdateMappingSourceItemApiArg = {
  structureId: number;
  sourceItemId: string;
  sourceItem: SourceItem;
};
export type GetSecretsApiResponse = /** status 200 OK */ SecretDtoRead[];
export type GetSecretsApiArg = {
  type?: SecretType;
};
export type CreateSecretApiResponse = /** status 200 OK */ SecretDtoRead;
export type CreateSecretApiArg = {
  secretDto: SecretDtoWrite;
};
export type DeleteSecretApiResponse = unknown;
export type DeleteSecretApiArg = {
  secretId: number;
};
export type GetSecretApiResponse = /** status 200 OK */ SecretDtoRead;
export type GetSecretApiArg = {
  secretId: number;
};
export type UpdateSecretApiResponse = /** status 200 OK */ SecretDtoRead;
export type UpdateSecretApiArg = {
  secretId: number;
  secretDto: SecretDtoWrite;
};
export type GetStructuresApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetStructuresApiArg = {
  type?: StructureType[];
  /** Structure ids */
  id?: number[];
  /** Structure UUIDs */
  uuid?: string[];
  /** Only locked structures */
  locked?: boolean;
  /** Filter structures locked by current user */
  lockedByMe?: boolean;
  /** Max level of the tree to return. ONLY from tree request */
  maxLevel?: number;
  /** JsonPath for filtering */
  jsonPath?: string;
  /** Id of the structure to start from */
  startFromId?: number;
  /** Search text */
  searchTerm?: string;
  /** Status of the structure, exact match */
  status?: string;
  pageSize?: number;
  pageNumber?: number;
  /** DEFAULT for search by criteria is order by rank */
  sortBy?: SortBy;
  /** Append included structures to the result (History/Reference table) */
  appendIncluded?: boolean;
};
export type CreateSystemApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type CreateSystemApiArg = {
  system: System;
};
export type GenerateScriptsApiResponse =
  /** status 200 Async TASK information */ AsyncTaskExecutionDto;
export type GenerateScriptsApiArg = {
  massExportExternalConfigDto: MassExportExternalConfigDto;
};
export type BulkUnlockApiResponse = unknown;
export type BulkUnlockApiArg = {
  force?: boolean;
  id: number[];
};
export type BulkLockApiResponse = unknown;
export type BulkLockApiArg = {
  force?: boolean;
  id: number[];
};
export type GetDeletedStructuresApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetDeletedStructuresApiArg = {
  search?: string;
  pageSize?: number;
  pageNumber?: number;
};
export type UndeleteStructureApiResponse = unknown;
export type UndeleteStructureApiArg = {
  structureId: number;
  newParentId?: number;
};
export type GetFullTreeApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetFullTreeApiArg = {
  type?: StructureType[];
  /** Structure ids */
  id?: number[];
  /** Structure UUIDs */
  uuid?: string[];
  /** Only locked structures */
  locked?: boolean;
  /** Filter structures locked by current user */
  lockedByMe?: boolean;
  /** Max level of the tree to return. ONLY from tree request */
  maxLevel?: number;
  /** JsonPath for filtering */
  jsonPath?: string;
  /** Id of the structure to start from */
  startFromId?: number;
  /** Search text */
  searchTerm?: string;
  /** Status of the structure, exact match */
  status?: string;
};
export type GetChildrenApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetChildrenApiArg = {
  parentId: number;
  type?: StructureType[];
  search?: string;
  pageSize?: number;
  pageNumber?: number;
  maxLevel?: number;
};
export type CreateStructureApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type CreateStructureApiArg = {
  parentId: number;
  type: BasicStructureTypeEnum;
  name: string;
};
export type GetStructureMetadataApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type GetStructureMetadataApiArg = {
  structureId: number;
};
export type GetStructureAclApiResponse = /** status 200 OK */ AclEntryDtoRead[];
export type GetStructureAclApiArg = {
  structureId: number;
};
export type CreateStructureAclApiResponse =
  /** status 200 OK */ AclEntryDtoRead;
export type CreateStructureAclApiArg = {
  structureId: number;
  aclEntryDto: AclEntryDto;
};
export type GetEffectiveAclApiResponse = /** status 200 OK */ AclEntryDtoRead[];
export type GetEffectiveAclApiArg = {
  structureId: number;
};
export type EvaluatePermissionsApiResponse =
  /** status 200 OK */ PermissionEvaluationDtoRead;
export type EvaluatePermissionsApiArg = {
  /** structure id */
  structureId: number;
  /** for specific user */
  forUserId?: number;
  /** for specific group */
  groupName?: string;
};
export type DeleteStructureAclApiResponse = unknown;
export type DeleteStructureAclApiArg = {
  structureId: number;
  aclId: number;
};
export type UpdateStructureAclApiResponse = unknown;
export type UpdateStructureAclApiArg = {
  structureId: number;
  aclId: number;
  aclEntryDto: AclEntryDto;
};
export type AsyncStructurePreviewApiResponse =
  /** status 200 Async TASK information */ AsyncTaskExecutionDto;
export type AsyncStructurePreviewApiArg = {
  structureId: number;
  objectTypeId: number;
};
export type CountApiResponse = /** status 200 OK */ {
  [key: string]: number;
};
export type CountApiArg = {
  structureId: number;
};
export type GetStructureHistoryApiResponse =
  /** status 200 OK */ PageWrapperHistoryWithDeploymentDto;
export type GetStructureHistoryApiArg = {
  structureId: number;
  pageNumber?: number;
  pageSize?: number;
};
export type CreateStructureHistoryApiResponse = /** status 200 OK */ HistoryDto;
export type CreateStructureHistoryApiArg = {
  structureId: number;
  description: string;
  fixImpacts?: boolean;
};
export type PrePushValidationApiResponse =
  /** status 200 OK */ PrePushValidationDto[];
export type PrePushValidationApiArg = {
  structureId: number;
};
export type GetStructureHistoryWithDeploymentApiResponse =
  /** status 200 OK */ HistoryWithDeploymentDto;
export type GetStructureHistoryWithDeploymentApiArg = {
  structureId: number;
  versionNumber: number;
};
export type ReplaceStructureVersionApiResponse =
  /** status 200 OK */ HistoryDto;
export type ReplaceStructureVersionApiArg = {
  structureId: number;
  versionNumber: number;
};
export type UnLockStructureApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type UnLockStructureApiArg = {
  structureId: number;
};
export type LockStructureApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead;
export type LockStructureApiArg = {
  structureId: number;
};
export type GetParentSystemApiResponse = /** status 200 OK */ System;
export type GetParentSystemApiArg = {
  structureId: number;
};
export type GetStructureTreeApiResponse =
  /** status 200 OK */ StructureMetadataDtoRead[];
export type GetStructureTreeApiArg = {
  structureId: number;
  type?: StructureType[];
  /** Structure ids */
  id?: number[];
  /** Structure UUIDs */
  uuid?: string[];
  /** Only locked structures */
  locked?: boolean;
  /** Filter structures locked by current user */
  lockedByMe?: boolean;
  /** Max level of the tree to return. ONLY from tree request */
  maxLevel?: number;
  /** JsonPath for filtering */
  jsonPath?: string;
  /** Id of the structure to start from */
  startFromId?: number;
  /** Search text */
  searchTerm?: string;
  /** Status of the structure, exact match */
  status?: string;
};
export type GetDeploymentPackagesApiResponse =
  /** status 200 OK */ PageWrapperReleaseDtoRead;
export type GetDeploymentPackagesApiArg = {
  systemId: number;
  status?: ReleaseStatusEnum;
  pageNumber?: number;
  pageSize?: number;
};
export type CreateDeploymentPackageApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type CreateDeploymentPackageApiArg = {
  systemId: number;
  releaseDto: ReleaseDtoWrite;
};
export type GetEnvGitBranchesApiResponse = /** status 200 OK */ string[];
export type GetEnvGitBranchesApiArg = {
  systemId: number;
  envCode: string;
};
export type GetStructureDetail1ApiResponse = /** status 200 OK */ Table;
export type GetStructureDetail1ApiArg = {
  structureId: number;
  version?: number;
};
export type UpdateTableApiResponse = unknown;
export type UpdateTableApiArg = {
  structureId: number;
  table: Table;
};
export type GetTableColumnsApiResponse = /** status 200 OK */ TableColumn[];
export type GetTableColumnsApiArg = {
  structureId: number;
};
export type AddTableColumnApiResponse = /** status 200 OK */ TableColumn;
export type AddTableColumnApiArg = {
  structureId: number;
  tableColumn: TableColumn;
};
export type UpdateTableColumnsApiResponse = /** status 200 OK */ TableColumn[];
export type UpdateTableColumnsApiArg = {
  structureId: number;
  body: TableColumn[];
};
export type DeleteTableColumnApiResponse = unknown;
export type DeleteTableColumnApiArg = {
  structureId: number;
  columnId: string;
};
export type UpdateTableColumnApiResponse = /** status 200 OK */ TableColumn;
export type UpdateTableColumnApiArg = {
  structureId: number;
  columnId: string;
  tableColumn: TableColumn;
};
export type GetTableConstraints2ApiResponse =
  /** status 200 OK */ TableConstraint[];
export type GetTableConstraints2ApiArg = {
  structureId: number;
};
export type AddTableConstraint2ApiResponse =
  /** status 200 OK */ TableConstraint;
export type AddTableConstraint2ApiArg = {
  structureId: number;
  tableConstraint: TableConstraint;
};
export type UpdateTableConstraints2ApiResponse =
  /** status 200 OK */ TableConstraint[];
export type UpdateTableConstraints2ApiArg = {
  structureId: number;
  body: TableConstraint[];
};
export type DeleteTableConstraint2ApiResponse = unknown;
export type DeleteTableConstraint2ApiArg = {
  structureId: number;
  constraintCode: string;
};
export type UpdateTableConstraint2ApiResponse =
  /** status 200 OK */ TableConstraint;
export type UpdateTableConstraint2ApiArg = {
  structureId: number;
  constraintCode: string;
  tableConstraint: TableConstraint;
};
export type GetStructureDetail3ApiResponse = /** status 200 OK */ HistoryTable;
export type GetStructureDetail3ApiArg = {
  structureId: number;
  version?: number;
};
export type UpdateTable2ApiResponse = unknown;
export type UpdateTable2ApiArg = {
  structureId: number;
  historyTable: HistoryTable;
};
export type GetTableColumns2ApiResponse = /** status 200 OK */ TableColumn[];
export type GetTableColumns2ApiArg = {
  structureId: number;
};
export type GetTableConstraints1ApiResponse =
  /** status 200 OK */ TableConstraint[];
export type GetTableConstraints1ApiArg = {
  structureId: number;
};
export type AddTableConstraint1ApiResponse =
  /** status 200 OK */ TableConstraint;
export type AddTableConstraint1ApiArg = {
  structureId: number;
  tableConstraint: TableConstraint;
};
export type UpdateTableConstraints1ApiResponse =
  /** status 200 OK */ TableConstraint[];
export type UpdateTableConstraints1ApiArg = {
  structureId: number;
  body: TableConstraint[];
};
export type DeleteTableConstraint1ApiResponse = unknown;
export type DeleteTableConstraint1ApiArg = {
  structureId: number;
  constraintCode: string;
};
export type UpdateTableConstraint1ApiResponse =
  /** status 200 OK */ TableConstraint;
export type UpdateTableConstraint1ApiArg = {
  structureId: number;
  constraintCode: string;
  tableConstraint: TableConstraint;
};
export type GetTableIndexes2ApiResponse = /** status 200 OK */ TableIndex[];
export type GetTableIndexes2ApiArg = {
  structureId: number;
};
export type AddTableIndex2ApiResponse = /** status 200 OK */ TableIndex;
export type AddTableIndex2ApiArg = {
  structureId: number;
  tableIndex: TableIndex;
};
export type UpdateTableIndexes2ApiResponse = /** status 200 OK */ TableIndex[];
export type UpdateTableIndexes2ApiArg = {
  structureId: number;
  body: TableIndex[];
};
export type DeleteTableIndex2ApiResponse = unknown;
export type DeleteTableIndex2ApiArg = {
  structureId: number;
  indexCode: string;
};
export type UpdateTableIndex2ApiResponse = /** status 200 OK */ TableIndex;
export type UpdateTableIndex2ApiArg = {
  structureId: number;
  indexCode: string;
  tableIndex: TableIndex;
};
export type GetTableOverview2ApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyHistoryTableRead;
export type GetTableOverview2ApiArg = {
  structureId: number;
};
export type UpdateTableOverview2ApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyHistoryTableRead;
export type UpdateTableOverview2ApiArg = {
  structureId: number;
  tableOverviewPartitioningStrategyHistoryTable: TableOverviewPartitioningStrategyHistoryTable;
};
export type DeleteTablePermission2ApiResponse = unknown;
export type DeleteTablePermission2ApiArg = {
  structureId: number;
  userCode?: string;
  userName?: string;
  userId?: number;
};
export type GetTablePermissions2ApiResponse =
  /** status 200 OK */ TablePermission[];
export type GetTablePermissions2ApiArg = {
  structureId: number;
};
export type SetTablePermission2ApiResponse =
  /** status 200 OK */ TablePermission;
export type SetTablePermission2ApiArg = {
  structureId: number;
  tablePermission: TablePermission;
};
export type GetTableScripts2ApiResponse = /** status 200 OK */ TableScripts;
export type GetTableScripts2ApiArg = {
  structureId: number;
};
export type UpdateTableScripts2ApiResponse = /** status 200 OK */ TableScripts;
export type UpdateTableScripts2ApiArg = {
  structureId: number;
  tableScripts: TableScripts;
};
export type GetTableIndexes1ApiResponse = /** status 200 OK */ TableIndex[];
export type GetTableIndexes1ApiArg = {
  structureId: number;
};
export type AddTableIndex1ApiResponse = /** status 200 OK */ TableIndex;
export type AddTableIndex1ApiArg = {
  structureId: number;
  tableIndex: TableIndex;
};
export type UpdateTableIndexes1ApiResponse = /** status 200 OK */ TableIndex[];
export type UpdateTableIndexes1ApiArg = {
  structureId: number;
  body: TableIndex[];
};
export type DeleteTableIndex1ApiResponse = unknown;
export type DeleteTableIndex1ApiArg = {
  structureId: number;
  indexCode: string;
};
export type UpdateTableIndex1ApiResponse = /** status 200 OK */ TableIndex;
export type UpdateTableIndex1ApiArg = {
  structureId: number;
  indexCode: string;
  tableIndex: TableIndex;
};
export type GetTableOverview1ApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type GetTableOverview1ApiArg = {
  structureId: number;
};
export type UpdateTableOverview1ApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type UpdateTableOverview1ApiArg = {
  structureId: number;
  tableOverviewPartitioningStrategyTable: TableOverviewPartitioningStrategyTable;
};
export type DeleteTablePermission1ApiResponse = unknown;
export type DeleteTablePermission1ApiArg = {
  structureId: number;
  userCode?: string;
  userName?: string;
  userId?: number;
};
export type GetTablePermissions1ApiResponse =
  /** status 200 OK */ TablePermission[];
export type GetTablePermissions1ApiArg = {
  structureId: number;
};
export type SetTablePermission1ApiResponse =
  /** status 200 OK */ TablePermission;
export type SetTablePermission1ApiArg = {
  structureId: number;
  tablePermission: TablePermission;
};
export type GetStructureDetail2ApiResponse =
  /** status 200 OK */ ReferenceTable;
export type GetStructureDetail2ApiArg = {
  structureId: number;
  version?: number;
};
export type UpdateTable1ApiResponse = unknown;
export type UpdateTable1ApiArg = {
  structureId: number;
  referenceTable: ReferenceTable;
};
export type GetTableColumns1ApiResponse = /** status 200 OK */ TableColumn[];
export type GetTableColumns1ApiArg = {
  structureId: number;
};
export type GetTableConstraintsApiResponse =
  /** status 200 OK */ TableConstraint[];
export type GetTableConstraintsApiArg = {
  structureId: number;
};
export type AddTableConstraintApiResponse =
  /** status 200 OK */ TableConstraint;
export type AddTableConstraintApiArg = {
  structureId: number;
  tableConstraint: TableConstraint;
};
export type UpdateTableConstraintsApiResponse =
  /** status 200 OK */ TableConstraint[];
export type UpdateTableConstraintsApiArg = {
  structureId: number;
  body: TableConstraint[];
};
export type DeleteTableConstraintApiResponse = unknown;
export type DeleteTableConstraintApiArg = {
  structureId: number;
  constraintCode: string;
};
export type UpdateTableConstraintApiResponse =
  /** status 200 OK */ TableConstraint;
export type UpdateTableConstraintApiArg = {
  structureId: number;
  constraintCode: string;
  tableConstraint: TableConstraint;
};
export type GetTableIndexesApiResponse = /** status 200 OK */ TableIndex[];
export type GetTableIndexesApiArg = {
  structureId: number;
};
export type AddTableIndexApiResponse = /** status 200 OK */ TableIndex;
export type AddTableIndexApiArg = {
  structureId: number;
  tableIndex: TableIndex;
};
export type UpdateTableIndexesApiResponse = /** status 200 OK */ TableIndex[];
export type UpdateTableIndexesApiArg = {
  structureId: number;
  body: TableIndex[];
};
export type DeleteTableIndexApiResponse = unknown;
export type DeleteTableIndexApiArg = {
  structureId: number;
  indexCode: string;
};
export type UpdateTableIndexApiResponse = /** status 200 OK */ TableIndex;
export type UpdateTableIndexApiArg = {
  structureId: number;
  indexCode: string;
  tableIndex: TableIndex;
};
export type GetTableOverviewApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type GetTableOverviewApiArg = {
  structureId: number;
};
export type UpdateTableOverviewApiResponse =
  /** status 200 OK */ TableOverviewPartitioningStrategyTableRead;
export type UpdateTableOverviewApiArg = {
  structureId: number;
  tableOverviewPartitioningStrategyTable: TableOverviewPartitioningStrategyTable;
};
export type DeleteTablePermissionApiResponse = unknown;
export type DeleteTablePermissionApiArg = {
  structureId: number;
  userCode?: string;
  userName?: string;
  userId?: number;
};
export type GetTablePermissionsApiResponse =
  /** status 200 OK */ TablePermission[];
export type GetTablePermissionsApiArg = {
  structureId: number;
};
export type SetTablePermissionApiResponse =
  /** status 200 OK */ TablePermission;
export type SetTablePermissionApiArg = {
  structureId: number;
  tablePermission: TablePermission;
};
export type GetTableScripts1ApiResponse = /** status 200 OK */ TableScripts;
export type GetTableScripts1ApiArg = {
  structureId: number;
};
export type UpdateTableScripts1ApiResponse = /** status 200 OK */ TableScripts;
export type UpdateTableScripts1ApiArg = {
  structureId: number;
  tableScripts: TableScripts;
};
export type GetTableScriptsApiResponse = /** status 200 OK */ TableScripts;
export type GetTableScriptsApiArg = {
  structureId: number;
};
export type UpdateTableScriptsApiResponse = /** status 200 OK */ TableScripts;
export type UpdateTableScriptsApiArg = {
  structureId: number;
  tableScripts: TableScripts;
};
export type GetAllTemplatesApiResponse =
  /** status 200 OK */ TemplateListDtoRead[];
export type GetAllTemplatesApiArg = {
  /** Technology id */
  technologyId?: number;
  /** Stereotype id */
  stereotypeId?: number;
};
export type CreateTemplateApiResponse =
  /** status 201 Created */ TemplateDtoRead;
export type CreateTemplateApiArg = {
  templateDto: TemplateDto;
};
export type DeleteTemplateApiResponse = unknown;
export type DeleteTemplateApiArg = {
  /** Template id */
  id: number;
};
export type GetTemplateApiResponse = /** status 200 OK */ TemplateDtoRead;
export type GetTemplateApiArg = {
  /** Template id */
  id: number;
};
export type UpdateTemplateApiResponse = /** status 200 OK */ TemplateDtoRead;
export type UpdateTemplateApiArg = {
  /** Template id */
  id: number;
  templateDto: TemplateDto;
};
export type GetTemplateHistoryApiResponse =
  /** status 200 OK */ TemplateListDtoRead[];
export type GetTemplateHistoryApiArg = {
  /** Template id */
  id: number;
};
export type GetTemplateHistoryDetailApiResponse =
  /** status 200 OK */ TemplateDtoRead;
export type GetTemplateHistoryDetailApiArg = {
  /** Template id */
  id: number;
  /** Template version */
  version: number;
};
export type PostTemplateLockApiResponse = unknown;
export type PostTemplateLockApiArg = {
  /** Template id */
  templateId: number;
};
export type PostTemplatePushApiResponse = unknown;
export type PostTemplatePushApiArg = {
  /** Template id */
  templateId: number;
  /** Unlock after push */
  unlock?: boolean;
};
export type PostTemplateUnlockApiResponse = unknown;
export type PostTemplateUnlockApiArg = {
  /** Template id */
  templateId: number;
};
export type GetTenantApiResponse = /** status 200 OK */ TenantDtoRead;
export type GetTenantApiArg = void;
export type UpdateTenantApiResponse = /** status 200 OK */ TenantDtoRead;
export type UpdateTenantApiArg = {
  tenantDto: TenantDto;
};
export type GetUsersApiResponse = /** status 200 OK */ PageWrapperUserDtoRead;
export type GetUsersApiArg = {
  search?: string;
  type?: UserType;
  pageSize?: number;
  pageNumber?: number;
};
export type AddUserApiResponse = /** status 200 OK */ UserDtoRead;
export type AddUserApiArg = {
  password?: string;
  userDto: UserDto;
};
export type GetApiUsersApiResponse = /** status 200 OK */ ApiUserDtoRead[];
export type GetApiUsersApiArg = void;
export type AddApiUserApiResponse = /** status 200 OK */ ApiUserDtoRead;
export type AddApiUserApiArg = {
  apiUserDto: ApiUserDto;
};
export type DeleteApiUserApiResponse = unknown;
export type DeleteApiUserApiArg = {
  clientId: string;
};
export type ApiUserUpdateApiResponse = /** status 200 OK */ ApiUserDtoRead;
export type ApiUserUpdateApiArg = {
  clientId: string;
  apiUserDto: ApiUserDto;
};
export type ApiUserResetSecretApiResponse = /** status 200 OK */ ApiUserDtoRead;
export type ApiUserResetSecretApiArg = {
  clientId: string;
};
export type GetSessionContextApiResponse =
  /** status 200 OK */ SessionContextDtoRead;
export type GetSessionContextApiArg = void;
export type UpdateSessionContextApiResponse =
  /** status 200 OK */ SessionContextDtoRead;
export type UpdateSessionContextApiArg = {
  sessionContextDto: SessionContextDto;
};
export type GetGroupsApiResponse = /** status 200 OK */ GroupDtoRead[];
export type GetGroupsApiArg = {
  pageSize?: number;
  pageNumber?: number;
};
export type CreateGroupApiResponse = /** status 200 OK */ GroupDtoRead;
export type CreateGroupApiArg = {
  groupDto: GroupDto;
};
export type DeleteGroupApiResponse = unknown;
export type DeleteGroupApiArg = {
  groupId: string;
};
export type UpdateGroupApiResponse = unknown;
export type UpdateGroupApiArg = {
  groupId: string;
  groupDto: GroupDto;
};
export type GetRolesForGroupApiResponse = /** status 200 OK */ RoleEnum[];
export type GetRolesForGroupApiArg = {
  groupId: string;
};
export type SetRolesForGroupApiResponse = unknown;
export type SetRolesForGroupApiArg = {
  groupId: string;
  body: ManagedRole[];
};
export type RemoveUserFromGroupApiResponse = unknown;
export type RemoveUserFromGroupApiArg = {
  groupId: string;
  userId: number[];
};
export type GetUsersInGroupApiResponse =
  /** status 200 OK */ PageWrapperUserDtoRead;
export type GetUsersInGroupApiArg = {
  groupId: string;
  pageSize?: number;
  pageNumber?: number;
};
export type AddUserToGroupApiResponse = unknown;
export type AddUserToGroupApiArg = {
  groupId: string;
  userId: number[];
};
export type GetUserListApiResponse = /** status 200 OK */ UserComboDto[];
export type GetUserListApiArg = void;
export type DeleteUserApiResponse = unknown;
export type DeleteUserApiArg = {
  userId: number;
};
export type GetUserApiResponse = /** status 200 OK */ UserDtoRead;
export type GetUserApiArg = {
  userId: number;
};
export type EditUserApiResponse = /** status 200 OK */ UserDtoRead;
export type EditUserApiArg = {
  userId: number;
  userDto: UserDto;
};
export type GetUserGroupsApiResponse = /** status 200 OK */ GroupDtoRead[];
export type GetUserGroupsApiArg = {
  userId: number;
};
export type UnLockUserApiResponse = unknown;
export type UnLockUserApiArg = {
  userId: number;
};
export type LockUserApiResponse = unknown;
export type LockUserApiArg = {
  userId: number;
};
export type ResetPasswordApiResponse = unknown;
export type ResetPasswordApiArg = {
  userId: number;
};
export type GetRolesForUserApiResponse = /** status 200 OK */ RoleEnum[];
export type GetRolesForUserApiArg = {
  userId: number;
};
export type SetRolesForUserApiResponse = unknown;
export type SetRolesForUserApiArg = {
  userId: number;
  body: ManagedRole[];
};
export type GetStructureDetailApiResponse = /** status 200 OK */ View;
export type GetStructureDetailApiArg = {
  structureId: number;
  version?: number;
};
export type UpdateViewApiResponse = unknown;
export type UpdateViewApiArg = {
  structureId: number;
  view: View;
};
export type GetViewColumnsApiResponse = /** status 200 OK */ ViewColumn[];
export type GetViewColumnsApiArg = {
  structureId: number;
};
export type AddViewColumnApiResponse = /** status 200 OK */ ViewColumn;
export type AddViewColumnApiArg = {
  structureId: number;
  viewColumn: ViewColumn;
};
export type UpdateViewColumnsApiResponse = /** status 200 OK */ ViewColumn[];
export type UpdateViewColumnsApiArg = {
  structureId: number;
  body: ViewColumn[];
};
export type UpdateViewColumn1ApiResponse = unknown;
export type UpdateViewColumn1ApiArg = {
  structureId: number;
  columnId: string;
};
export type UpdateViewColumnApiResponse = /** status 200 OK */ ViewColumn;
export type UpdateViewColumnApiArg = {
  structureId: number;
  columnId: string;
  viewColumn: ViewColumn;
};
export type GetViewOverviewApiResponse = /** status 200 OK */ ViewOverviewRead;
export type GetViewOverviewApiArg = {
  structureId: number;
};
export type UpdateViewOverviewApiResponse =
  /** status 200 OK */ ViewOverviewRead;
export type UpdateViewOverviewApiArg = {
  structureId: number;
  viewOverview: ViewOverview;
};
export type GetViewPermissionsApiResponse =
  /** status 200 OK */ ViewPermission[];
export type GetViewPermissionsApiArg = {
  structureId: number;
};
export type SetViewPermissionApiResponse = /** status 200 OK */ ViewPermission;
export type SetViewPermissionApiArg = {
  structureId: number;
  viewPermission: ViewPermission;
};
export type DeleteViewPermissionApiResponse = unknown;
export type DeleteViewPermissionApiArg = {
  structureId: number;
  userCode: string;
};
export type GetViewSourcesApiResponse = /** status 200 OK */ SourceItem[];
export type GetViewSourcesApiArg = {
  structureId: number;
};
export type AddViewSourceItemApiResponse = /** status 200 OK */ SourceItem;
export type AddViewSourceItemApiArg = {
  structureId: number;
  sourceItem: SourceItem;
};
export type UpdateViewSourceItemsApiResponse =
  /** status 200 OK */ SourceItem[];
export type UpdateViewSourceItemsApiArg = {
  structureId: number;
  body: SourceItem[];
};
export type GetViewSourcesDataApiResponse =
  /** status 200 OK */ ViewSourcesData;
export type GetViewSourcesDataApiArg = {
  structureId: number;
};
export type UpdateViewSourcesDataApiResponse = unknown;
export type UpdateViewSourcesDataApiArg = {
  structureId: number;
  viewSourcesData: ViewSourcesData;
};
export type DeleteViewSourceItemApiResponse = unknown;
export type DeleteViewSourceItemApiArg = {
  structureId: number;
  sourceItemId: string;
};
export type UpdateViewSourceItemApiResponse = /** status 200 OK */ SourceItem;
export type UpdateViewSourceItemApiArg = {
  structureId: number;
  sourceItemId: string;
  sourceItem: SourceItem;
};
export type ExpectationProviderDto = {
  code: string;
  description?: string;
  name: string;
  providerVersion: string;
};
export type ExpectationProviderDtoRead = {
  code: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  providerVersion: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type DataTypeEnum = "STRING" | "NUMBER" | "BOOLEAN" | "DATETIME";
export type ExpectationGroupCode =
  | "RANGE"
  | "SETS_AND_LISTS"
  | "PATTERNS"
  | "BASIC";
export type ExpectationAdminDto = {
  active: boolean;
  allowedDataTypes: DataTypeEnum[];
  code: string;
  description?: string;
  expectationType: string;
  groupCode: ExpectationGroupCode;
  name: string;
  providerId: number;
  templateText: string;
};
export type ExpectationAdminDtoRead = {
  active: boolean;
  allowedDataTypes: DataTypeEnum[];
  code: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  expectationType: string;
  groupCode: ExpectationGroupCode;
  id?: number;
  name: string;
  providerCode?: string;
  providerId: number;
  templateText: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type TableConstraintColumn = {
  code?: string;
  foreignColumnCode?: string;
  foreignColumnUuid?: string;
  name?: string;
  order?: number;
  uuid?: string;
};
export type ReferenceObjectInfo = {
  code?: string;
  id: number;
  uuid?: string;
};
export type ReferenceObjectInfoRead = {
  code?: string;
  id: number;
  name?: string;
  uuid?: string;
};
export type Cardinality =
  | "ONE"
  | "MANY"
  | "ONE_ONLY"
  | "ONE_OR_MANY"
  | "ZERO_OR_ONE"
  | "ZERO_OR_MANY";
export type ForeignKey = {
  code?: string;
  columns?: TableConstraintColumn[];
  comment?: string;
  name?: string;
  source?: ReferenceObjectInfo;
  sourceCardinality?: Cardinality;
  target?: ReferenceObjectInfo;
  targetCardinality?: Cardinality;
  uuid?: string;
};
export type ForeignKeyRead = {
  code?: string;
  columns?: TableConstraintColumn[];
  comment?: string;
  name?: string;
  source?: ReferenceObjectInfoRead;
  sourceCardinality?: Cardinality;
  target?: ReferenceObjectInfoRead;
  targetCardinality?: Cardinality;
  uuid?: string;
};
export type CustomAttribute = {
  id?: string;
  name?: string;
  source?: string;
  value?: any;
  version?: string;
};
export type TableColumnDomain = {
  code?: string;
  id?: number;
  name?: string;
};
export type DefinitionKind =
  | "odcs_library"
  | "sql"
  | "expectation"
  | "free_text";
export type Dimension =
  | "accuracy"
  | "completeness"
  | "conformity"
  | "consistency"
  | "coverage"
  | "timeliness"
  | "uniqueness";
export type ExpectationDefinitionRef = {
  code?: string;
  providerCode?: string;
};
export type Kwargs = any;
export type Representation = any;
export type Expectation = {
  definition?: ExpectationDefinitionRef;
  kwargs?: Kwargs;
  representation?: Representation;
};
export type Arguments = any;
export type OdcsLibrary = {
  arguments?: Arguments;
  metric?: string;
  operator?: string;
};
export type Severity = "error" | "warning" | "info";
export type DqRuleSql = {
  operator?: any;
  query?: string;
};
export type DqRule = {
  definitionKind?: DefinitionKind;
  description?: string;
  dimension?: Dimension;
  expectation?: Expectation;
  freeText?: string;
  library?: OdcsLibrary;
  name?: string;
  severity?: Severity;
  sql?: DqRuleSql;
  uuid?: string;
};
export type TableColumnStereotype = {
  code?: string;
  id?: number;
  name?: string;
};
export type TableColumn = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  dataType?: string;
  defaultValue?: string;
  description?: string;
  domain?: TableColumnDomain;
  foreignKey?: boolean;
  g_hasTemplate?: boolean;
  g_isTextValue?: boolean;
  g_template?: string;
  ghasTemplate?: boolean;
  gisTextValue?: boolean;
  gtemplate?: string;
  historyColumn?: boolean;
  id?: number;
  mandatory?: boolean;
  name?: string;
  notNull?: boolean;
  notNullFlag?: boolean;
  odcsDqRules?: DqRule[];
  order?: number;
  primaryKey?: boolean;
  stereotype?: TableColumnStereotype;
  stereotypeColumn?: boolean;
  technicalColumnId?: number;
  uuid?: string;
  virtualColumnScript?: string;
};
export type ConstraintType =
  | "primary_key"
  | "foreign_key"
  | "custom"
  | "unique"
  | "check";
export type TableConstraint = {
  code?: string;
  columns?: TableConstraintColumn[];
  comment?: string;
  constraintType?: ConstraintType;
  description?: string;
  enabled?: boolean;
  expression?: string;
  foreignKeyTableId?: number;
  foreignKeyTableUuid?: string;
  g_foreignKeyTableCode?: string;
  g_foreignKeyTableOwner?: string;
  gforeignKeyTableCode?: string;
  gforeignKeyTableOwner?: string;
  id?: number;
  name?: string;
  order?: number;
  physicalOptions?: string;
  script?: string;
  sourceCardinality?: Cardinality;
  targetCardinality?: Cardinality;
};
export type EntityType =
  | "aggregate"
  | "auxiliary"
  | "composition"
  | "fundamental"
  | "metadata"
  | "relation"
  | "snapshot"
  | "specialisation"
  | "transaction";
export type SortType = "ASC" | "DESC";
export type TableIndexColumn = {
  code?: string;
  order?: number;
  sortType?: SortType;
  uuid?: string;
};
export type TableIndex = {
  code?: string;
  columns?: TableIndexColumn[];
  comment?: string;
  description?: string;
  id?: number;
  isUnique?: boolean;
  name?: string;
  order?: number;
  physicalOptions?: string;
};
export type NonSyncFieldTable =
  | "uuid"
  | "name"
  | "code"
  | "comment"
  | "description"
  | "stereotypeId"
  | "stereotypeCode"
  | "subStereotypeId"
  | "hasHistoryTable"
  | "hasReferenceTable"
  | "businessDomainId"
  | "businessDomainName"
  | "entityType"
  | "status"
  | "responsibleAnalystId"
  | "responsibleAnalystName"
  | "responsiblePersonId"
  | "responsiblePersonName"
  | "retentionStrategy"
  | "retentionStrategyFullHistoryValue"
  | "retentionStrategyFullHistoryUnit"
  | "retentionStrategyEomValue"
  | "retentionStrategyEomUnit"
  | "columns"
  | "columnsLastId"
  | "indexes"
  | "indexesLastId"
  | "constraints"
  | "constraintsLastId"
  | "historyTable"
  | "referenceTable"
  | "script"
  | "preTableScript"
  | "postTableScript"
  | "partitioningStrategy"
  | "partitioningColumnId"
  | "partitioningColumnCode"
  | "sequenceCode"
  | "sequenceColumnCode"
  | "ownerId"
  | "ownerName"
  | "objectSettings"
  | "customAttributes";
export type TablePermissionEnum =
  | "ALTER"
  | "SELECT"
  | "DELETE"
  | "UPDATE"
  | "INSERT"
  | "REFERENCE"
  | "SEQUENCE";
export type SystemUser = {
  code?: string;
  comment?: string;
  description?: string;
  id?: number;
  name?: string;
};
export type TablePermission = {
  id?: number;
  order?: number;
  permissions?: TablePermissionEnum[];
  user?: SystemUser;
};
export type ObjectSettings = {
  code?: string;
  id?: number;
  name?: string;
};
export type Parent = {
  code?: string;
  name?: string;
};
export type PartitioningStrategyHistoryTable =
  | "no_partition"
  | "key"
  | "source_system"
  | "snapshot_data"
  | "source_and_snapshot"
  | "key_and_snapshot"
  | "source_and_snapshot_and_date_effective"
  | "key_and_snapshot_and_date_effective"
  | "source_system_and_valid_to";
export type RetentionStrategy =
  | "infinite"
  | "delete_after"
  | "move_after"
  | "keep_full_history"
  | "keep_full_history_and_eom";
export type RetentionTimeUnit = "day" | "month" | "year";
export type Status =
  | "logical_in_progress"
  | "logical_completed"
  | "physical_in_progress"
  | "physical_completed"
  | "frozen";
export type HistoryTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_isHistoryTable?: boolean;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gisHistoryTable?: boolean;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  nonSyncFields?: NonSyncFieldTable[];
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  originalTable?: Parent;
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyHistoryTable;
  postTableScript?: string;
  preTableScript?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type PartitioningStrategyTable =
  | "no_partition"
  | "key"
  | "source_system"
  | "snapshot_data"
  | "source_and_snapshot"
  | "key_and_snapshot"
  | "source_and_snapshot_and_date_effective"
  | "key_and_snapshot_and_date_effective";
export type ReferenceTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_isReferenceTable?: boolean;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gisReferenceTable?: boolean;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  nonSyncFields?: NonSyncFieldTable[];
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  originalTable?: Parent;
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  postTableScript?: string;
  preTableScript?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type Table = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  historyTable?: HistoryTable;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  odcsDqRules?: DqRule[];
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  postTableScript?: string;
  preTableScript?: string;
  referenceTable?: ReferenceTable;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type StructureType =
  | "ROOT"
  | "SYSTEM"
  | "FOLDER"
  | "FOLDER_WORKFLOW"
  | "TABLE"
  | "MAPPING_DEFAULT"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "CONSTANT_DOMAIN"
  | "TABLE_COLUMN"
  | "DIAGRAM";
export type StructureDtoTable = {
  code?: string;
  data?: Table;
  id?: number;
  lastUpdatedAt?: string;
  name?: string;
  parentId?: number;
  type?: StructureType;
  uuid?: string;
  version?: number;
};
export type DiagramDataResponse = {
  foreignKeys?: ForeignKey[];
  notFoundTableIds?: number[];
  tables?: StructureDtoTable[];
};
export type DiagramDataResponseRead = {
  foreignKeys?: ForeignKeyRead[];
  notFoundTableIds?: number[];
  tables?: StructureDtoTable[];
};
export type Inspector = any;
export type Point = {
  x?: number;
  y?: number;
};
export type LinkData = {
  code?: string;
  from?: number;
  fromPort?: string;
  key?: number;
  linksColor?: string;
  points?: Point[];
  text?: string;
  to?: number;
  toPort?: string;
};
export type ModelData = any;
export type NodeData = {
  category?: string;
  code?: string;
  columns?: TableColumn[];
  key?: number;
  loc?: string;
  nodeBodyColor?: string;
  nodeHeaderColor?: string;
  tableColumnsVisibility?: boolean;
  text?: string;
  version?: number;
};
export type DisplayOptions = {
  columnsCode?: boolean;
  columnsName?: boolean;
  comments?: boolean;
  description?: boolean;
  hasName?: boolean;
  pkColumnsCode?: boolean;
  pkColumnsName?: boolean;
  tableCode?: boolean;
  tableColumns?: boolean;
  tableName?: boolean;
};
export type LineColors = {
  horizontal?: string;
  intervalHorizontal?: string;
  intervalVertical?: string;
  vertical?: string;
};
export type Grid = {
  cellSize?: number;
  isVisible?: boolean;
  lineColors?: LineColors;
};
export type Links = {
  color?: string;
  routingType?: string;
};
export type Body = {
  color?: string;
};
export type Header = {
  color?: string;
};
export type Node = {
  body?: Body;
  header?: Header;
};
export type DiagramProperties = {
  displayOptions?: DisplayOptions;
  grid?: Grid;
  links?: Links;
  node?: Node;
};
export type Diagram = {
  inspector?: Inspector;
  linkDataArray?: LinkData[];
  modelData?: ModelData;
  nodeDataArray?: NodeData[];
  properties?: DiagramProperties;
};
export type NewDiagram = {
  code?: string;
  comment?: string;
  description?: string;
  graph?: Diagram;
  name?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  svg?: string;
  uuid?: string;
};
export type UserInfoDto = {
  id: number;
};
export type UserInfoDtoRead = {
  email?: string;
  fullName?: string;
  id: number;
  loginName?: string;
};
export type DiagramOverview = {
  code?: string;
  comment?: string;
  description?: string;
  name?: string;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type DiagramOverviewRead = {
  code?: string;
  comment?: string;
  description?: string;
  name?: string;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type UserType = "STANDARD" | "ADMIN" | "READER" | "API";
export type UserDto = {
  department?: string;
  description?: string;
  email: string;
  loginName: string;
  name: string;
  surname: string;
  type?: UserType;
};
export type UserDtoRead = {
  canBeEdited?: boolean;
  companyName?: string;
  compositeName?: string;
  deleted?: boolean;
  department?: string;
  description?: string;
  email: string;
  hardLock?: boolean;
  id?: number;
  loginName: string;
  name: string;
  support?: boolean;
  surname: string;
  type?: UserType;
};
export type ReleaseStatusEnum = "OPEN" | "CANCEL" | "COMPLETED";
export type ReleaseDto = {
  description?: string;
  name?: string;
  responsibleUser?: UserDto;
  status?: ReleaseStatusEnum;
};
export type ReleaseDtoRead = {
  canEditWholeContent?: boolean;
  canReadWholeContent?: boolean;
  description?: string;
  id?: number;
  name?: string;
  responsibleUser?: UserDtoRead;
  status?: ReleaseStatusEnum;
};
export type ReleaseDtoWrite = {
  description?: string;
  name?: string;
  responsibleUser?: UserDto;
  responsibleUserId?: number;
  status?: ReleaseStatusEnum;
};
export type ReleaseEnvironmentDto = {
  code?: string;
  id?: number;
  name?: string;
  releaseDate?: string;
  released?: boolean;
  releasedTime?: string;
};
export type MassExportSorting =
  | "DEFAULT"
  | "SORT_BY_NAME_ASC"
  | "SORT_BY_TYPE_AND_NAME_ASC";
export type MassExportStrategy =
  | "ZIP_PER_STRUCTURE"
  | "ZIP_OWNER_FOLDER_PER_OBJECT_TYPE"
  | "ZIP_PER_OWNER_AND_OBJECT_TYPE"
  | "SINGLE_FILE";
export type StructureTypeObjTypes = {
  [key: string]: string[];
};
export type MassExportExternalConfigDto = {
  /** Optional if empty >> PREVIEW */
  environmentCode?: string;
  ignoreErrors?: boolean;
  massExportSorting?: MassExportSorting;
  massExportStrategy?: MassExportStrategy;
  structureIds?: number[];
  structureObjectPairs?: StructureTypeObjTypes;
  /** Optional */
  structureStatus?: Status[];
  /** Timestamp of the structure version to be exported. */
  structureTimestamp?: string;
  /** Timestamp of the template version to be exported. */
  templateTimestamp?: string;
};
export type MddError = {
  errorCode?: string;
  errorDescription?: string;
  errorMessage?: string;
};
export type ObjectSettingsDto = {
  code: string;
  comment?: string;
  defaultFlag?: boolean;
  description?: string;
  name: string;
  structureType?: StructureType;
};
export type ObjectSettingsDtoRead = {
  code: string;
  comment?: string;
  createdAt?: string;
  createdBy?: string;
  defaultFlag?: boolean;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  structureType?: StructureType;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type DeploymentInfo = {
  deployedHistoryId?: number;
  deployedVersion?: number;
  id?: string;
  objectTypeCode?: string;
  pushedHistoryId?: number;
  pushedVersion?: number;
};
export type EnvInfo = {
  deploymentInfo?: DeploymentInfo[];
  envCode?: string;
  frontendId?: number;
};
export type Permission = "VIEW" | "EDIT" | "MANAGE_ACCESS" | "FORCE_UNLOCK";
export type StructureReleaseInfoDto = {
  code?: string;
  deleted?: boolean;
  environmentInfo?: EnvInfo[];
  fullPath?: string;
  name?: string;
  parentStructureId?: number;
  permissions?: Permission[];
  structureId?: number;
  type?: StructureType;
};
export type PageWrapperStructureReleaseInfoDto = {
  content?: StructureReleaseInfoDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type ExpectationDto = {
  active?: boolean;
  allowedDataTypes?: DataTypeEnum[];
  code?: string;
  description?: string;
  expectationType?: string;
  groupCode?: ExpectationGroupCode;
  id?: number;
  name?: string;
  providerCode?: string;
  providerId?: number;
};
export type TrueFalseInheritType = "true" | "false" | "inherit";
export type LetterCaseEnum = "upperCase" | "lowerCase";
export type NamingConfig = {
  generateCode?: TrueFalseInheritType;
  generateTableColumnCode?: TrueFalseInheritType;
  letterCase?: LetterCaseEnum;
};
export type StatusEnum = "draft" | "under" | "review" | "published" | "retired";
export type BasicData = {
  limitations?: string;
  purpose?: string;
  status?: StatusEnum;
  tenant?: string;
  usage?: string;
};
export type ExecuteReadNode = {
  id?: string;
  inputParameter?: string;
  mappingCode?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
  waitUntilFinishedFlag?: boolean;
};
export type Method = "call_mapping" | "run_mapping" | "run_script";
export type ExecuteWriteNode = {
  id?: string;
  inputParameter?: string;
  mappingCode?: string;
  method?: Method;
  name?: string;
  onOffFlag?: boolean;
  script?: string;
  throwEvent?: string;
  waitUntilFinishedFlag?: boolean;
};
export type FinishNode = {
  id?: string;
  name?: string;
  script?: string;
  throwEvent?: string;
};
export type Interval = "daily" | "weekly" | "monthly";
export type Start = "interval" | "cron" | "workflow_finish" | "run_script";
export type Weekday =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";
export type InitNode = {
  cron?: string;
  day?: number;
  hour?: number;
  id?: string;
  interval?: Interval;
  minute?: number;
  name?: string;
  otherWorkflowCode?: string;
  script?: string;
  start?: Start;
  throwEvent?: string;
  weekday?: Weekday;
};
export type Link = {
  from?: string;
  g_fromCode?: string;
  g_toCode?: string;
  gfromCode?: string;
  gtoCode?: string;
  to?: string;
};
export type LockResourceNode = {
  id?: string;
  inputParameter?: string;
  name?: string;
  onOffFlag?: boolean;
  resourceName?: string;
  throwEvent?: string;
};
export type ParallelMergeNode = {
  id?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
};
export type ParallelStartNode = {
  id?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
};
export type SubflowExecuteNode = {
  id?: string;
  inputParameter?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
  waitUntilFinishedFlag?: boolean;
};
export type UnlockResourceNode = {
  id?: string;
  inputParameter?: string;
  name?: string;
  onOffFlag?: boolean;
  resourceName?: string;
  throwEvent?: string;
};
export type WaitForEventNode = {
  eventName?: string;
  id?: string;
  name?: string;
  onOffFlag?: boolean;
  throwEvent?: string;
};
export type WorkflowGraph = {
  executeReadNodes?: ExecuteReadNode[];
  executeWriteNodes?: ExecuteWriteNode[];
  finishNode?: FinishNode;
  initNode?: InitNode;
  links?: Link[];
  lockResourceNodes?: LockResourceNode[];
  parallelMergeNodes?: ParallelMergeNode[];
  parallelStartNodes?: ParallelStartNode[];
  subflowExecuteNodes?: SubflowExecuteNode[];
  unlockResourceNodes?: UnlockResourceNode[];
  waitForEventNodes?: WaitForEventNode[];
};
export type Folder = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  namingConfig?: NamingConfig;
  objectSettings?: ObjectSettings[];
  odcs?: BasicData;
  ownerId?: number;
  ownerName?: string;
  stereotypeCode?: string;
  stereotypeId?: number;
  uuid?: string;
  workflow?: WorkflowGraph;
};
export type FolderOverview = {
  businessDomain?: ReferenceObjectInfo;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  namingConfig?: NamingConfig;
  owner?: SystemUser;
  stereotype?: ReferenceObjectInfo;
};
export type FolderOverviewRead = {
  businessDomain?: ReferenceObjectInfoRead;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  namingConfig?: NamingConfig;
  owner?: SystemUser;
  stereotype?: ReferenceObjectInfoRead;
};
export type AsyncTaskState =
  | "NEW"
  | "RUNNING"
  | "ERROR"
  | "FINISHED"
  | "CANCELLED";
export type AsyncTaskType =
  | "MASS_EXPORT"
  | "UPDATE_TECHNICAL_COLUMNS"
  | "UPDATE_NAMING"
  | "IMPORT_STRUCTURES"
  | "PREVIEW";
export type AsyncTaskExecutionDto = {
  createdAt?: string;
  createdBy?: string;
  errorMessage?: string;
  id?: number;
  itemDone?: number;
  itemTotal?: number;
  /** Progress in % */
  progress?: number;
  state?: AsyncTaskState;
  type?: AsyncTaskType;
  updatedAt?: string;
};
export type ExistingElementsEnum = "OVERWRITE" | "MERGE";
export type FkMissingTable = "IGNORE" | "IMPORT";
export type FkMoreTables = "IGNORE" | "IMPORT_EXITING" | "IMPORT_IMPORTED";
export type StructureExportDto = {
  actualData?: string;
  children?: StructureExportDto[];
  code?: string;
  name?: string;
  type?: StructureType;
};
export type ReturnMessageTypeEnum =
  | "INCOMPATIBLE_TARGET"
  | "CUSTOM_ATTRIBUTE_NOT_FOUND"
  | "OBJECT_SETTING_NOT_FOUND"
  | "OWNER_NOT_FOUND"
  | "BUSINESS_DOMAIN_NOT_FOUND"
  | "RESPONSIBLE_ANALYST_NOT_FOUND"
  | "RESPONSIBLE_PERSON_NOT_FOUND"
  | "DOMAIN_NOT_FOUND"
  | "STEREOTYPE_NOT_FOUND"
  | "TABLE_ALREADY_EXISTS"
  | "INCONSISTENT_TABLES"
  | "INCONSISTENT_DOMAINS"
  | "COLUMN_WITH_SAME_NAME_ALREADY_EXISTS"
  | "COLUMN_WITH_SAME_CODE_ALREADY_EXISTS"
  | "DUPLICATE_COLUMN_NAME"
  | "DUPLICATE_COLUMN_CODE"
  | "TECHNICAL_COLUMN_COLLISION"
  | "SYSTEM_USER_NOT_FOUND";
export type ReturnMessage = {
  detail?: string;
  messageType?: ReturnMessageTypeEnum;
  object?: string;
};
export type CheckResult = {
  errors?: ReturnMessage[];
  warnings?: ReturnMessage[];
};
export type Id = {
  code?: string;
  id?: number;
  name?: string;
  originalId?: number;
  originalUuid?: string;
  type?: StructureType;
  uuid?: string;
};
export type Structure = {
  data?: any;
  id?: Id;
  locked?: boolean;
  parentId?: Id;
  type?: StructureType;
};
export type AcronymDto = {
  acronym: string;
  text: string;
};
export type AcronymDtoRead = {
  acronym: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  id?: number;
  text: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperAcronymDto = {
  content?: AcronymDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperAcronymDtoRead = {
  content?: AcronymDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type Direction = "ASC" | "DESC";
export type BusinessDomainDto = {
  description?: string;
  name: string;
};
export type BusinessDomainDtoRead = {
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperBusinessDomainDto = {
  content?: BusinessDomainDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperBusinessDomainDtoRead = {
  content?: BusinessDomainDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type CustomAttributeGroupDto = {
  code?: string;
  name?: string;
  ordering?: number;
};
export type CustomAttributeGroupDtoRead = {
  code?: string;
  id?: number;
  name?: string;
  ordering?: number;
};
export type PageWrapperCustomAttributeGroupDto = {
  content?: CustomAttributeGroupDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperCustomAttributeGroupDtoRead = {
  content?: CustomAttributeGroupDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type CustomLovValueComboDto = {
  label?: string;
  ordering?: number;
  value?: string;
};
export type CustomLovDto = {
  description?: string;
  lovValues?: CustomLovValueComboDto[];
  name: string;
};
export type CustomLovDtoRead = {
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  lovValues?: CustomLovValueComboDto[];
  name: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperCustomLovDto = {
  content?: CustomLovDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperCustomLovDtoRead = {
  content?: CustomLovDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type LovReference = {
  code?: string;
  id: number;
};
export type LovReferenceRead = {
  code?: string;
  id: number;
  name?: string;
};
export type CustomAttributeStructureTypeEnum =
  | "SYSTEM"
  | "FOLDER"
  | "FOLDER_WORKFLOW"
  | "TABLE"
  | "TABLE_COLUMN"
  | "MAPPING_DEFAULT"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE";
export type CustomAttributeTypeEnum =
  | "STRING"
  | "SCRIPT"
  | "NUMBER"
  | "BOOLEAN"
  | "LOV"
  | "ARRAY";
export type CustomAttributeDto = {
  customLovId?: number;
  description?: string;
  group?: LovReference;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
};
export type CustomAttributeDtoRead = {
  createdAt?: string;
  createdBy?: string;
  customLovId?: number;
  deleted?: boolean;
  description?: string;
  group?: LovReferenceRead;
  id?: number;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperCustomAttributeDto = {
  content?: CustomAttributeDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperCustomAttributeDtoRead = {
  content?: CustomAttributeDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type DomainTechnologyV2Dto = {
  dataType: string;
  defaultValue?: string;
  technology: LovReference;
};
export type DomainTechnologyV2DtoRead = {
  dataType: string;
  defaultValue?: string;
  id: number;
  technology: LovReferenceRead;
};
export type DomainV2Dto = {
  code: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  description?: string;
  domainTechnologies?: DomainTechnologyV2Dto[];
  hasTemplate: boolean;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
};
export type DomainV2DtoRead = {
  code: string;
  createdAt?: string;
  createdBy?: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  deleted?: boolean;
  description?: string;
  domainTechnologies?: DomainTechnologyV2DtoRead[];
  hasTemplate: boolean;
  id: number;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageWrapperDomainV2Dto = {
  content?: DomainV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperDomainV2DtoRead = {
  content?: DomainV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type ImpactChangeCodeListDto = {
  affectedElements?: {
    [key: string]: number;
  };
};
export type DomainTechnologyDto = {
  dataType: string;
  defaultValue?: string;
  id: number;
  technologyCode: string;
  technologyId?: number;
};
export type DomainUpdateDto = {
  code: string;
  companyName: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  description?: string;
  domainTechnologies?: DomainTechnologyDto[];
  hasTemplate: boolean;
  id: number;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
};
export type PageWrapperObjectSettingsDto = {
  content?: ObjectSettingsDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperObjectSettingsDtoRead = {
  content?: ObjectSettingsDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type StereotypeCategory = "BEHAVIORAL" | "DEFAULT" | "USER_DEFINED";
export type StereotypeType =
  | "FOLDER"
  | "TABLE"
  | "TABLE_INTERFACE"
  | "TABLE_HISTORY"
  | "COLUMN"
  | "MAPPING"
  | "MAPPING_TYPE"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "CONSTANT_DOMAIN"
  | "VIEW"
  | "WORKFLOW"
  | "API_NODE"
  | "API_NODE_ATTRIBUTE"
  | "API_ROWSET"
  | "QUEUE"
  | "TABLE_COLUMN"
  | "DIAGRAM";
export type StereotypeV2Dto = {
  category: StereotypeCategory;
  code: string;
  description?: string;
  name: string;
  type: StereotypeType;
};
export type StereotypeV2DtoRead = {
  category: StereotypeCategory;
  code: string;
  description?: string;
  id: number;
  internal?: boolean;
  name: string;
  type: StereotypeType;
};
export type PageWrapperStereotypeV2Dto = {
  content?: StereotypeV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperStereotypeV2DtoRead = {
  content?: StereotypeV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type TechnicalColumnV2Dto = {
  code: string;
  comment?: string;
  description?: string;
  domain: LovReference;
  name: string;
  notNull?: boolean;
  ordering?: number;
  stereotypeColumn?: LovReference;
  stereotypes?: LovReference[];
  virtualColumnScript?: string;
};
export type TechnicalColumnV2DtoRead = {
  code: string;
  comment?: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  domain: LovReferenceRead;
  id?: number;
  name: string;
  notNull?: boolean;
  ordering?: number;
  stereotypeColumn?: LovReferenceRead;
  stereotypes?: LovReferenceRead[];
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
  virtualColumnScript?: string;
};
export type PageWrapperTechnicalColumnV2Dto = {
  content?: TechnicalColumnV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperTechnicalColumnV2DtoRead = {
  content?: TechnicalColumnV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type TechnologyType = "SYSTEM" | "WORKFLOW";
export type TechnologyV2Dto = {
  code: string;
  description: string;
  name: string;
  type: TechnologyType;
};
export type TechnologyV2DtoRead = {
  code: string;
  description: string;
  id: number;
  name: string;
  type: TechnologyType;
};
export type PageWrapperTechnologyV2Dto = {
  content?: TechnologyV2Dto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperTechnologyV2DtoRead = {
  content?: TechnologyV2DtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type MappingColumn = {
  columnCode?: string;
  customAttributes?: CustomAttribute[];
  dataType?: string;
  defaultValue?: string;
  g_code?: string;
  g_mandatory?: boolean;
  gcode?: string;
  gmandatory?: boolean;
  groupByFlag?: boolean;
  id?: number;
  keyFlag?: boolean;
  mapping?: string;
  mappingComment?: string;
  mappingDescription?: string;
  notNull?: boolean;
  order?: number;
  outerMapping?: string;
  stereotypeColumnCode?: string;
  updateFlag?: boolean;
  uuid?: string;
};
export type DefaultMappingType = "none" | "history" | "interface" | "reference";
export type MappingPermissionEnum = "EXECUTE" | "DEBUG";
export type MappingPermission = {
  id?: number;
  order?: number;
  permissions?: MappingPermissionEnum[];
  user?: SystemUser;
};
export type ObjectType = "TABLE" | "VIEW" | "SUB_SELECT" | "DUMMY";
export type Stereotype =
  | "from"
  | "join"
  | "left join"
  | "left outer join"
  | "right join"
  | "right outer join"
  | "full outer join"
  | "cross join"
  | "union"
  | "union all";
export type SourceItem = {
  alias?: string;
  comment?: string;
  description?: string;
  expression?: string;
  g_table?: Table;
  gtable?: Table;
  id?: number;
  objectCode?: string;
  objectCustom?: string;
  objectId?: number;
  objectType?: ObjectType;
  objectUuid?: string;
  order?: number;
  owner?: string;
  ownerId?: number;
  ownerName?: string;
  sourceContext?: string;
  stereotype?: Stereotype;
  uuid?: string;
};
export type Mapping = {
  code?: string;
  columns?: MappingColumn[];
  columnsLastId?: number;
  comment?: string;
  criteria?: string;
  criteriaDescription?: string;
  customAttributes?: CustomAttribute[];
  defaultMappingType?: DefaultMappingType;
  description?: string;
  distinct?: boolean;
  g_key_columns?: MappingColumn[];
  g_templateStereotype?: string;
  g_templateVersion?: number;
  g_update_columns?: MappingColumn[];
  gkeyColumns?: MappingColumn[];
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  gupdateColumns?: MappingColumn[];
  mappingContextScript?: string;
  mappingContextScriptDescription?: string;
  mappingDeleteContextScript?: string;
  mappingDeleteContextScriptDescription?: string;
  name?: string;
  objectPermissionLastId?: number;
  objectPermissions?: MappingPermission[];
  objectSettings?: ObjectSettings[];
  outWhere?: string;
  outWhereDescription?: string;
  ownerId?: number;
  ownerName?: string;
  postMappingScript?: string;
  postMappingScriptDescription?: string;
  preMappingScript?: string;
  preMappingScriptDescription?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  sourceHints?: string;
  sourceHintsDescription?: string;
  sourceItems?: SourceItem[];
  sourceItemsLastId?: number;
  sources?: string;
  sourcesDescription?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  targetCriteria?: string;
  targetCriteriaDescription?: string;
  targetHints?: string;
  targetHintsDescription?: string;
  truncate?: boolean;
  uuid?: string;
};
export type ScriptDto = {
  description?: string;
  script?: string;
};
export type MappingOtherScriptsDto = {
  context?: ScriptDto;
  deleteContext?: ScriptDto;
  outWhere?: ScriptDto;
  postMapping?: ScriptDto;
  preMapping?: ScriptDto;
  sourceHints?: ScriptDto;
  targetHints?: ScriptDto;
};
export type MappingOverview = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  distinct?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
  truncate?: boolean;
};
export type MappingOverviewRead = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  distinct?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
  truncate?: boolean;
};
export type MappingSourcesData = {
  criteria?: ScriptDto;
  sources?: ScriptDto;
  targetCriteria?: ScriptDto;
};
export type SecretType = "GIT_TOKEN";
export type SecretDto = {
  description?: string;
  name?: string;
  owner?: UserInfoDto;
  type?: SecretType;
  validTo?: string;
};
export type SecretDtoRead = {
  description?: string;
  id?: number;
  name?: string;
  owner?: UserInfoDtoRead;
  type?: SecretType;
  validTo?: string;
};
export type SecretDtoWrite = {
  description?: string;
  name?: string;
  owner?: UserInfoDto;
  type?: SecretType;
  validTo?: string;
  value?: string;
};
export type StructureReferenceDto = {
  code?: string;
  id?: number;
  type?: StructureType;
  uuid?: string;
};
export type StructureMetadataDto = {
  code?: string;
  fullPath?: string;
  id?: number;
  lastModifiedBy?: UserInfoDto;
  lastModifiedTime?: string;
  lockedFor?: UserInfoDto;
  lockedTime?: string;
  name?: string;
  orderPriority?: number;
  parent?: StructureReferenceDto;
  permissions?: Permission[];
  status?: string;
  type?: StructureType;
  uuid?: string;
};
export type StructureMetadataDtoRead = {
  code?: string;
  fullPath?: string;
  id?: number;
  lastModifiedBy?: UserInfoDtoRead;
  lastModifiedTime?: string;
  lockedFor?: UserInfoDtoRead;
  lockedTime?: string;
  name?: string;
  orderPriority?: number;
  parent?: StructureReferenceDto;
  permissions?: Permission[];
  status?: string;
  type?: StructureType;
  uuid?: string;
};
export type SortBy = "DEFAULT" | "NAME" | "TYPE" | "CHANGED";
export type MappingItem = {
  code?: string;
  comment?: string;
  dataType?: string;
  description?: string;
  domainCode?: string;
  domainId?: number;
  id?: number;
  name?: string;
  value?: string;
};
export type Environment = {
  code?: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  gitDefaultBranch?: string;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id?: number;
  name?: string;
  production?: boolean;
  rememberPassword?: boolean;
};
export type System = {
  code?: string;
  constants?: MappingItem[];
  constantsLastId?: number;
  customAttributes?: CustomAttribute[];
  diagram?: Diagram;
  environments?: Environment[];
  environmentsLastId?: number;
  lookups?: MappingItem[];
  lookupsLastId?: number;
  name?: string;
  namingConfig?: NamingConfig;
  ownerId?: number;
  ownerName?: string;
  systemTechnologyId?: number;
  systemUsers?: SystemUser[];
  systemUsersLastId?: number;
  uuid?: string;
  workflowTechnologyId?: number;
};
export type StructureDto = {
  authorId?: number;
  authorName?: string;
  canEdit: boolean;
  code: string;
  companyId: number;
  description?: string;
  fullPath?: string;
  hasChildren: boolean;
  id: number;
  lockTime?: string;
  lockUserId?: number;
  lockUserName?: string;
  name: string;
  orderPriority?: number;
  parentStructureId?: number;
  status?: string;
  type: StructureType;
  uuid?: string;
};
export type BasicStructureTypeEnum =
  | "SYSTEM"
  | "FOLDER"
  | "TABLE"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "DIAGRAM";
export type AclEntryDto = {
  allowedPermissions?: Permission[];
  deniedPermissions?: Permission[];
  groupName?: string;
};
export type AclEntryDtoRead = {
  allowedPermissions?: Permission[];
  deniedPermissions?: Permission[];
  groupName?: string;
  id?: number;
};
export type PermissionSourceDto = {
  aclEntryId?: number;
  groupName?: string;
  structure?: StructureMetadataDto;
};
export type PermissionSourceDtoRead = {
  aclEntryId?: number;
  groupName?: string;
  structure?: StructureMetadataDtoRead;
};
export type PermissionEvaluationItemDto = {
  allowedFrom?: PermissionSourceDto[];
  deniedFrom?: PermissionSourceDto[];
  granted?: boolean;
  permission?: Permission;
};
export type PermissionEvaluationItemDtoRead = {
  allowedFrom?: PermissionSourceDtoRead[];
  deniedFrom?: PermissionSourceDtoRead[];
  granted?: boolean;
  permission?: Permission;
};
export type PermissionEvaluationDto = {
  permissions?: PermissionEvaluationItemDto[];
  structure?: StructureMetadataDto;
};
export type PermissionEvaluationDtoRead = {
  permissions?: PermissionEvaluationItemDtoRead[];
  structure?: StructureMetadataDtoRead;
};
export type SqlType =
  | "TABLE_HISTORY"
  | "TABLE_REFERENCE"
  | "TABLE"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "FOLDER";
export type DeploymentDto = {
  authorId: number;
  authorName: string;
  created: string;
  description: string;
  environmentCode?: string;
  environmentFeId: number;
  environmentId: number;
  id: number;
  releaseId?: number;
  sqlType: SqlType;
  structureHistoryId: number;
  structureId: number;
  templateId: number;
  version: number;
};
export type HistoryWithDeploymentDto = {
  authorId: number;
  authorName: string;
  created: string;
  deployments?: DeploymentDto[];
  description?: string;
  id: number;
  structureId: number;
  version: number;
};
export type PageWrapperHistoryWithDeploymentDto = {
  content?: HistoryWithDeploymentDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type HistoryDto = {
  authorId: number;
  authorName: string;
  created: string;
  description?: string;
  id: number;
  structureId: number;
  version: number;
};
export type PrePushValidationType =
  | "BROKEN_LINK"
  | "BROKEN_FK"
  | "MISSING_REQ_FIELD"
  | "MAPPING_COLUMN_CHANGED"
  | "DELETED_COLUMN"
  | "DELETED_IDX"
  | "DELETED_CONSTRAINT"
  | "SOME_EXPECTED_VALUE_MISSING"
  | "SOME_VALUE_REMOVED"
  | "UNIQUE_UUID";
export type PrePushValidationDto = {
  allowedIgnore?: boolean;
  editableByActualUser?: boolean;
  message?: string;
  path?: string;
  structureId?: number;
  structureType?: StructureType;
  type?: PrePushValidationType;
};
export type PageWrapperReleaseDto = {
  content?: ReleaseDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperReleaseDtoRead = {
  content?: ReleaseDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperReleaseDtoWrite = {
  content?: ReleaseDtoWrite[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type TableOverviewPartitioningStrategyHistoryTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyHistoryTable;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type TableOverviewPartitioningStrategyHistoryTableRead = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyHistoryTable;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type TableScripts = {
  postTableScript?: string;
  preTableScript?: string;
  script?: string;
};
export type TableOverviewPartitioningStrategyTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type TableOverviewPartitioningStrategyTableRead = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  hasHistoryTable?: boolean;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type FormatType = "PYTHON" | "SQL" | "PLAIN_TEXT";
export type TemplateListDto = {
  author?: UserInfoDto;
  comment?: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDto;
  objectSettings?: ReferenceObjectInfo;
  stereotype?: ReferenceObjectInfo;
  structureType?: StructureType;
  technology: ReferenceObjectInfo;
};
export type TemplateListDtoRead = {
  author?: UserInfoDtoRead;
  comment?: string;
  created?: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDtoRead;
  objectSettings?: ReferenceObjectInfoRead;
  stereotype?: ReferenceObjectInfoRead;
  structureType?: StructureType;
  technology: ReferenceObjectInfoRead;
  version?: number;
};
export type TemplateDto = {
  author?: UserInfoDto;
  comment?: string;
  data: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  lockedBy?: UserInfoDto;
  objectSettings?: ReferenceObjectInfo;
  stereotype?: ReferenceObjectInfo;
  structureType?: StructureType;
  technology: ReferenceObjectInfo;
};
export type TemplateDtoRead = {
  author?: UserInfoDtoRead;
  comment?: string;
  created?: string;
  data: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDtoRead;
  objectSettings?: ReferenceObjectInfoRead;
  stereotype?: ReferenceObjectInfoRead;
  structureType?: StructureType;
  technology: ReferenceObjectInfoRead;
  version?: number;
};
export type TenantDto = {
  information?: string;
};
export type TenantDtoRead = {
  id?: number;
  information?: string;
  name?: string;
};
export type PageWrapperUserDto = {
  content?: UserDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageWrapperUserDtoRead = {
  content?: UserDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type ApiUserDto = {
  clientId?: string;
  description?: string;
  name?: string;
  owner?: UserInfoDto;
  writeAccess?: boolean;
};
export type ApiUserDtoRead = {
  clientId?: string;
  clientSecret?: string;
  description?: string;
  name?: string;
  owner?: UserInfoDtoRead;
  writeAccess?: boolean;
};
export type SessionContextDto = {
  context?: string;
  user?: UserDto;
};
export type SessionContextDtoRead = {
  context?: string;
  user?: UserDtoRead;
};
export type GroupDto = {
  description?: string;
  name?: string;
};
export type GroupDtoRead = {
  description?: string;
  id?: string;
  name?: string;
};
export type RoleEnum =
  | "SUPER_ADMIN"
  | "MANAGE_USERS"
  | "MANAGE_LOV"
  | "CREATE_DELETE_SYSTEM"
  | "EXT_SYSTEM"
  | "EXT_SYSTEM_WRITE"
  | "ADMIN"
  | "READER"
  | "SUPPORT"
  | "MANAGE_TEMPLATES"
  | "MANAGE_CREDENTIALS";
export type ManagedRole =
  | "MANAGE_USERS"
  | "MANAGE_LOV"
  | "CREATE_DELETE_SYSTEM"
  | "MANAGE_TEMPLATES"
  | "MANAGE_CREDENTIALS";
export type UserComboDto = {
  id: number;
  value: string;
};
export type ViewColumn = {
  code?: string;
  comment?: string;
  description?: string;
  id?: number;
  mapping?: string;
  name?: string;
  uuid?: string;
};
export type ViewPermissionEnum =
  | "ALTER"
  | "SELECT"
  | "DELETE"
  | "UPDATE"
  | "INSERT"
  | "REFERENCE";
export type ViewPermission = {
  id?: number;
  order?: number;
  permissions?: ViewPermissionEnum[];
  user?: SystemUser;
};
export type View = {
  code?: string;
  columns?: ViewColumn[];
  columnsLastId?: number;
  comment?: string;
  criteriaDescription?: string;
  criteriaScript?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  g_templateVersion?: number;
  gtemplateVersion?: number;
  name?: string;
  objectPermissionLastId?: number;
  objectPermissions?: ViewPermission[];
  objectSettings?: ObjectSettings[];
  ownerId?: number;
  ownerName?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  sourceDescription?: string;
  sourceItems?: SourceItem[];
  sourceItemsLastId?: number;
  sourceScript?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  uuid?: string;
};
export type ViewOverview = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDto;
  responsiblePerson?: UserInfoDto;
  status?: Status;
  stereotype?: ReferenceObjectInfo;
};
export type ViewOverviewRead = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  description?: string;
  name?: string;
  objectSettings?: ObjectSettings[];
  owner?: SystemUser;
  responsibleAnalyst?: UserInfoDtoRead;
  responsiblePerson?: UserInfoDtoRead;
  status?: Status;
  stereotype?: ReferenceObjectInfoRead;
};
export type ViewSourcesData = {
  criteria?: ScriptDto;
  source?: ScriptDto;
};
export const {
  useGetProvidersAdminQuery,
  useLazyGetProvidersAdminQuery,
  useCreateProviderAdminMutation,
  useDeleteProviderAdminMutation,
  useGetProviderAdminQuery,
  useLazyGetProviderAdminQuery,
  useUpdateProviderAdminMutation,
  useGetExpectationsAdminQuery,
  useLazyGetExpectationsAdminQuery,
  useCreateExpectationAdminMutation,
  useDeleteExpectationAdminMutation,
  useGetExpectationAdminQuery,
  useLazyGetExpectationAdminQuery,
  useUpdateExpectationAdminMutation,
  useGetDataForDiagramQuery,
  useLazyGetDataForDiagramQuery,
  useGetDiagramByIdQuery,
  useLazyGetDiagramByIdQuery,
  useUpdateDiagramMutation,
  useGetDiagramDataQuery,
  useLazyGetDiagramDataQuery,
  useUpdateDiagramDataMutation,
  useGetDiagramOverviewQuery,
  useLazyGetDiagramOverviewQuery,
  useUpdateDiagramOverviewMutation,
  useGetDiagramSvgQuery,
  useLazyGetDiagramSvgQuery,
  useUpdateDiagramSvgMutation,
  useDeleteSystemReleaseMutation,
  useGetSystemReleaseQuery,
  useLazyGetSystemReleaseQuery,
  useUpdateSystemReleaseMutation,
  useGetReleaseEnvironmentsQuery,
  useLazyGetReleaseEnvironmentsQuery,
  useCreateReleaseEnvironmentMutation,
  useDeleteReleaseEnvironmentMutation,
  useUpdateReleaseEnvironmentMutation,
  usePushReleaseToGitMutation,
  useCreateReleasePreviewMutation,
  useCreateReleaseScriptsMutation,
  useCreateDeploymentsMutation,
  useGetObjectSettingsQuery,
  useLazyGetObjectSettingsQuery,
  useChangeReleaseStatusMutation,
  useGetReleaseStructuresQuery,
  useLazyGetReleaseStructuresQuery,
  useAddStructureToReleaseMutation,
  useDeleteReleaseStructureMutation,
  useGetProvidersQuery,
  useLazyGetProvidersQuery,
  useGetExpectationsQuery,
  useLazyGetExpectationsQuery,
  useGetStructureDetail5Query,
  useLazyGetStructureDetail5Query,
  useUpdateFolderMutation,
  useGetOdcsQuery,
  useLazyGetOdcsQuery,
  useUpdateOdcsMutation,
  useSetOdcsStatusMutation,
  useGetFolderOverviewQuery,
  useLazyGetFolderOverviewQuery,
  useUpdateFolderOverviewMutation,
  useImportStructuresMutation,
  useCheckJsonMutation,
  useGetImportResultQuery,
  useLazyGetImportResultQuery,
  useGetAllLovAcronymQuery,
  useLazyGetAllLovAcronymQuery,
  useCreateLovAcronymMutation,
  useDeleteLovAcronymMutation,
  useGetLovAcronymQuery,
  useLazyGetLovAcronymQuery,
  useUpdateLovAcronymMutation,
  useGetAllLovBusinessDomainQuery,
  useLazyGetAllLovBusinessDomainQuery,
  useCreateLovBusinessDomainMutation,
  useDeleteLovBusinessDomainMutation,
  useGetLovBusinessDomainQuery,
  useLazyGetLovBusinessDomainQuery,
  useUpdateLovBusinessDomainMutation,
  useGetAllLovCustomAttributeGroupQuery,
  useLazyGetAllLovCustomAttributeGroupQuery,
  useCreateLovCustomAttributeGroupMutation,
  useDeleteLovCustomAttributeGroupMutation,
  useGetLovCustomAttributeGroupQuery,
  useLazyGetLovCustomAttributeGroupQuery,
  useUpdateLovCustomAttributeGroupMutation,
  useGetAllLovCustomAttributeLovQuery,
  useLazyGetAllLovCustomAttributeLovQuery,
  useCreateLovCustomAttributeLovMutation,
  useDownloadCustomLovsLovCustomAttributeLovQuery,
  useLazyDownloadCustomLovsLovCustomAttributeLovQuery,
  useDeleteLovCustomAttributeLovMutation,
  useGetLovCustomAttributeLovQuery,
  useLazyGetLovCustomAttributeLovQuery,
  useUpdateLovCustomAttributeLovMutation,
  useGetAllLovCustomAttributeQuery,
  useLazyGetAllLovCustomAttributeQuery,
  useCreateLovCustomAttributeMutation,
  useDeleteLovCustomAttributeMutation,
  useGetLovCustomAttributeQuery,
  useLazyGetLovCustomAttributeQuery,
  useUpdateLovCustomAttributeMutation,
  useGetAllLovDomainQuery,
  useLazyGetAllLovDomainQuery,
  useCreateLovDomainMutation,
  useDeleteLovDomainMutation,
  useGetLovDomainQuery,
  useLazyGetLovDomainQuery,
  useUpdateLovDomainMutation,
  useComputeImpactDomainChangeLovDomainMutation,
  useGetAllLovObjectTypeQuery,
  useLazyGetAllLovObjectTypeQuery,
  useCreateLovObjectTypeMutation,
  useDeleteLovObjectTypeMutation,
  useGetLovObjectTypeQuery,
  useLazyGetLovObjectTypeQuery,
  useUpdateLovObjectTypeMutation,
  useGetAllLovStereotypeQuery,
  useLazyGetAllLovStereotypeQuery,
  useCreateLovStereotypeMutation,
  useDeleteLovStereotypeMutation,
  useGetLovStereotypeQuery,
  useLazyGetLovStereotypeQuery,
  useUpdateLovStereotypeMutation,
  useGetAllLovTechnicalColumnQuery,
  useLazyGetAllLovTechnicalColumnQuery,
  useCreateLovTechnicalColumnMutation,
  useDeleteLovTechnicalColumnMutation,
  useGetLovTechnicalColumnQuery,
  useLazyGetLovTechnicalColumnQuery,
  useUpdateLovTechnicalColumnMutation,
  useComputeImpactTcChangeLovTechnicalColumnMutation,
  useGetAllLovTechnologyQuery,
  useLazyGetAllLovTechnologyQuery,
  useGetStructureDetail4Query,
  useLazyGetStructureDetail4Query,
  useUpdateMappingMutation,
  useGetMappingColumnsQuery,
  useLazyGetMappingColumnsQuery,
  useAddMappingColumnMutation,
  useUpdateMappingColumnsMutation,
  useUpdateMappingColumn1Mutation,
  useUpdateMappingColumnMutation,
  useGetMappingOtherScriptsQuery,
  useLazyGetMappingOtherScriptsQuery,
  useUpdateMappingOtherScriptsMutation,
  useGetMappingOverviewQuery,
  useLazyGetMappingOverviewQuery,
  useUpdateMappingOverviewMutation,
  useGetMappingPermissionsQuery,
  useLazyGetMappingPermissionsQuery,
  useSetMappingPermissionMutation,
  useDeleteMappingPermissionMutation,
  useGetMappingSourcesQuery,
  useLazyGetMappingSourcesQuery,
  useAddMappingSourceItemMutation,
  useUpdateMappingSourceItemsMutation,
  useGetMappingSourcesDataQuery,
  useLazyGetMappingSourcesDataQuery,
  useUpdateMappingSourcesDataMutation,
  useDeleteMappingSourceItemMutation,
  useUpdateMappingSourceItemMutation,
  useGetSecretsQuery,
  useLazyGetSecretsQuery,
  useCreateSecretMutation,
  useDeleteSecretMutation,
  useGetSecretQuery,
  useLazyGetSecretQuery,
  useUpdateSecretMutation,
  useGetStructuresQuery,
  useLazyGetStructuresQuery,
  useCreateSystemMutation,
  useGenerateScriptsMutation,
  useBulkUnlockMutation,
  useBulkLockMutation,
  useGetDeletedStructuresQuery,
  useLazyGetDeletedStructuresQuery,
  useUndeleteStructureMutation,
  useGetFullTreeQuery,
  useLazyGetFullTreeQuery,
  useGetChildrenQuery,
  useLazyGetChildrenQuery,
  useCreateStructureMutation,
  useGetStructureMetadataQuery,
  useLazyGetStructureMetadataQuery,
  useGetStructureAclQuery,
  useLazyGetStructureAclQuery,
  useCreateStructureAclMutation,
  useGetEffectiveAclQuery,
  useLazyGetEffectiveAclQuery,
  useEvaluatePermissionsQuery,
  useLazyEvaluatePermissionsQuery,
  useDeleteStructureAclMutation,
  useUpdateStructureAclMutation,
  useAsyncStructurePreviewMutation,
  useCountQuery,
  useLazyCountQuery,
  useGetStructureHistoryQuery,
  useLazyGetStructureHistoryQuery,
  useCreateStructureHistoryMutation,
  usePrePushValidationQuery,
  useLazyPrePushValidationQuery,
  useGetStructureHistoryWithDeploymentQuery,
  useLazyGetStructureHistoryWithDeploymentQuery,
  useReplaceStructureVersionMutation,
  useUnLockStructureMutation,
  useLockStructureMutation,
  useGetParentSystemQuery,
  useLazyGetParentSystemQuery,
  useGetStructureTreeQuery,
  useLazyGetStructureTreeQuery,
  useGetDeploymentPackagesQuery,
  useLazyGetDeploymentPackagesQuery,
  useCreateDeploymentPackageMutation,
  useGetEnvGitBranchesQuery,
  useLazyGetEnvGitBranchesQuery,
  useGetStructureDetail1Query,
  useLazyGetStructureDetail1Query,
  useUpdateTableMutation,
  useGetTableColumnsQuery,
  useLazyGetTableColumnsQuery,
  useAddTableColumnMutation,
  useUpdateTableColumnsMutation,
  useDeleteTableColumnMutation,
  useUpdateTableColumnMutation,
  useGetTableConstraints2Query,
  useLazyGetTableConstraints2Query,
  useAddTableConstraint2Mutation,
  useUpdateTableConstraints2Mutation,
  useDeleteTableConstraint2Mutation,
  useUpdateTableConstraint2Mutation,
  useGetStructureDetail3Query,
  useLazyGetStructureDetail3Query,
  useUpdateTable2Mutation,
  useGetTableColumns2Query,
  useLazyGetTableColumns2Query,
  useGetTableConstraints1Query,
  useLazyGetTableConstraints1Query,
  useAddTableConstraint1Mutation,
  useUpdateTableConstraints1Mutation,
  useDeleteTableConstraint1Mutation,
  useUpdateTableConstraint1Mutation,
  useGetTableIndexes2Query,
  useLazyGetTableIndexes2Query,
  useAddTableIndex2Mutation,
  useUpdateTableIndexes2Mutation,
  useDeleteTableIndex2Mutation,
  useUpdateTableIndex2Mutation,
  useGetTableOverview2Query,
  useLazyGetTableOverview2Query,
  useUpdateTableOverview2Mutation,
  useDeleteTablePermission2Mutation,
  useGetTablePermissions2Query,
  useLazyGetTablePermissions2Query,
  useSetTablePermission2Mutation,
  useGetTableScripts2Query,
  useLazyGetTableScripts2Query,
  useUpdateTableScripts2Mutation,
  useGetTableIndexes1Query,
  useLazyGetTableIndexes1Query,
  useAddTableIndex1Mutation,
  useUpdateTableIndexes1Mutation,
  useDeleteTableIndex1Mutation,
  useUpdateTableIndex1Mutation,
  useGetTableOverview1Query,
  useLazyGetTableOverview1Query,
  useUpdateTableOverview1Mutation,
  useDeleteTablePermission1Mutation,
  useGetTablePermissions1Query,
  useLazyGetTablePermissions1Query,
  useSetTablePermission1Mutation,
  useGetStructureDetail2Query,
  useLazyGetStructureDetail2Query,
  useUpdateTable1Mutation,
  useGetTableColumns1Query,
  useLazyGetTableColumns1Query,
  useGetTableConstraintsQuery,
  useLazyGetTableConstraintsQuery,
  useAddTableConstraintMutation,
  useUpdateTableConstraintsMutation,
  useDeleteTableConstraintMutation,
  useUpdateTableConstraintMutation,
  useGetTableIndexesQuery,
  useLazyGetTableIndexesQuery,
  useAddTableIndexMutation,
  useUpdateTableIndexesMutation,
  useDeleteTableIndexMutation,
  useUpdateTableIndexMutation,
  useGetTableOverviewQuery,
  useLazyGetTableOverviewQuery,
  useUpdateTableOverviewMutation,
  useDeleteTablePermissionMutation,
  useGetTablePermissionsQuery,
  useLazyGetTablePermissionsQuery,
  useSetTablePermissionMutation,
  useGetTableScripts1Query,
  useLazyGetTableScripts1Query,
  useUpdateTableScripts1Mutation,
  useGetTableScriptsQuery,
  useLazyGetTableScriptsQuery,
  useUpdateTableScriptsMutation,
  useGetAllTemplatesQuery,
  useLazyGetAllTemplatesQuery,
  useCreateTemplateMutation,
  useDeleteTemplateMutation,
  useGetTemplateQuery,
  useLazyGetTemplateQuery,
  useUpdateTemplateMutation,
  useGetTemplateHistoryQuery,
  useLazyGetTemplateHistoryQuery,
  useGetTemplateHistoryDetailQuery,
  useLazyGetTemplateHistoryDetailQuery,
  usePostTemplateLockMutation,
  usePostTemplatePushMutation,
  usePostTemplateUnlockMutation,
  useGetTenantQuery,
  useLazyGetTenantQuery,
  useUpdateTenantMutation,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useAddUserMutation,
  useGetApiUsersQuery,
  useLazyGetApiUsersQuery,
  useAddApiUserMutation,
  useDeleteApiUserMutation,
  useApiUserUpdateMutation,
  useApiUserResetSecretMutation,
  useGetSessionContextQuery,
  useLazyGetSessionContextQuery,
  useUpdateSessionContextMutation,
  useGetGroupsQuery,
  useLazyGetGroupsQuery,
  useCreateGroupMutation,
  useDeleteGroupMutation,
  useUpdateGroupMutation,
  useGetRolesForGroupQuery,
  useLazyGetRolesForGroupQuery,
  useSetRolesForGroupMutation,
  useRemoveUserFromGroupMutation,
  useGetUsersInGroupQuery,
  useLazyGetUsersInGroupQuery,
  useAddUserToGroupMutation,
  useGetUserListQuery,
  useLazyGetUserListQuery,
  useDeleteUserMutation,
  useGetUserQuery,
  useLazyGetUserQuery,
  useEditUserMutation,
  useGetUserGroupsQuery,
  useLazyGetUserGroupsQuery,
  useUnLockUserMutation,
  useLockUserMutation,
  useResetPasswordMutation,
  useGetRolesForUserQuery,
  useLazyGetRolesForUserQuery,
  useSetRolesForUserMutation,
  useGetStructureDetailQuery,
  useLazyGetStructureDetailQuery,
  useUpdateViewMutation,
  useGetViewColumnsQuery,
  useLazyGetViewColumnsQuery,
  useAddViewColumnMutation,
  useUpdateViewColumnsMutation,
  useUpdateViewColumn1Mutation,
  useUpdateViewColumnMutation,
  useGetViewOverviewQuery,
  useLazyGetViewOverviewQuery,
  useUpdateViewOverviewMutation,
  useGetViewPermissionsQuery,
  useLazyGetViewPermissionsQuery,
  useSetViewPermissionMutation,
  useDeleteViewPermissionMutation,
  useGetViewSourcesQuery,
  useLazyGetViewSourcesQuery,
  useAddViewSourceItemMutation,
  useUpdateViewSourceItemsMutation,
  useGetViewSourcesDataQuery,
  useLazyGetViewSourcesDataQuery,
  useUpdateViewSourcesDataMutation,
  useDeleteViewSourceItemMutation,
  useUpdateViewSourceItemMutation,
} = injectedRtkApi;
